import { cifAe, cifEg } from "@coreui/icons";
import { colors } from "../../src/utils/const";
import { userAgent } from "@/utils/generalUrils";
import Box from "@mui/material/Box";

export default {
  terms: "https://contact.eg/terms-and-conditions-ar.pdf",
  contact: "كونتكت",
  // ** CONTACT

  contact_supervision:
    "ترخيص الهيئة العامة للرقابة المالية رقم 756 بتاريخ 2018/04/18",
  // ** form page
  CategoriesForm1: [
    "اجهزاة منزلية و أليكترونيات",
    "وسائل الترفيه و السياحة",
    "سيارات و درجات",
    "اجهزاة منزلية",
    "أجهزة محمول",
    "أثاثات و البيت",
    "ملابس",
    // "الجمال",
    "مجوهرات",
    "الصحة",
    "الجمال",
    "العائلة و الحيونات الاليفة",
    "تعليم",
    "خدمات",
    "الرياضة و العافية",
    "سوبر ماركت",
    "مأكولات و مشروبات",
    "البيت",
    "متاجر و الأسواق",
    "الهدايا",
    "الاعمال",
  ],
  POSform1: ["باي موب", "باي تابس", "فوري", "جيديا", "كاشير", "نتورك", "اخري"],
  partner_types: [
    { id: "1", title: "انضم كشريك للتأجير التمويلي" },
    { id: "2", title: "انضم كشريك للتخصيم" },
    { id: "3", title: "ابدأ شراكتك مع كونتكت" },
    // { id: "4", title: "تجار كونتكت ناو" },
  ],

  form_title1: "شبكة تجار كونتكت ناو",
  form_sub1: "عملاء أكثر ونجاح أكبر",
  form_des1:
    "من خلال خبراتنا التمويلية الطويلة بالسوق المصري وفريق عملنا المتخصص سنمكنك من إطلاق العنان لمجال أعمالك. ستساعدك اجراءاتنا البسيطة وحلولنا التمويلية المختلفة في تحقيق المزيد من المبيعات والوصول إلى شرائح مختلفة من العملاء. انضم الينا الآن من خلال تسجيل متجرك مع كونتكت ناو",
  form_title2: "انضم كشريك للتأجير التمويلي",
  form_sub2: "توريدات المعدات الطبية من كونتكت",
  form_des2:
    "احصل على المعدات والسيارات التي تحتاجها شركتك بأقساط تناسب أعمالك، مع إمكانية التملّك في نهاية العقد.",
  form_title3: "انضم كشريك للتخصيم",
  form_sub3: "توريدات سيارات ومعدات النقل من كونتكت",
  form_des3:
    "مع حلول التخصيم من كونتكت، مبيعاتك الآجلة توفّر لك سيولة لتغطية احتياجات شركتك ودعم خطوتك القادمة.",
  form_title4: "ابدأ شراكتك مع كونتكت",
  form_sub4: "توريد منتجات وخدمات متنوعة",
  form_des4:
    "إذا كنت تقدم أي منتجات أو خدمات آخرى وترغب في توفير المزيد من خطط السداد لعملائك مع كونتكت، يرجى تسجيل بياناتك وسوف يقوم أحد مندوبينا بالتواصل معك.",
  yes: "نعم",
  no: "لا",
  have_record: "هل لديك سجل تجاري و بطاقة ضريبية؟",
  company_nameForm1: "اسم الشركه",
  company_nameForm2: "اسم الشركة التجارية ",
  company_nameForm3: "اسم الشركة  ",
  full_name: "الإسم الكامل للشخص الذي يمكن الاتصال به",
  // client_name: "اسم العميل",
  business_name: "اسم العمل",
  specialist_name: "اسم الشخص المختص",
  phone: "رقم الموبايل",
  email: "البريد الالكتروني",
  categories: "الفئات",
  url: "رابط الموقع او الفيسبوك",
  address: "العنوان بالتفصيل",
  governorate: "المحافظة",
  branchesNumber: "عدد الفروع",
  employees_number: "عدد الموظفين",
  field: "مجال العمل",
  digital: "منصة الاكترونية",
  POS: "هل لديك أي من ألات نقاط البيع المذكورة  أدناه ؟",
  send: "ارسال",
  // ** ----- extra -----
  plans: "خطط التقسيط",
  // \u202B.\u202C
  popup: (
    <>
      <p style={{ marginBottom: "6px" }}>
        <span dir="rtl">تمويل من غير حدود مع كونتكت!</span>
      </p>{" "}
      <p>اشتري في مصر، وقسط من الإمارات</p>
    </>
  ),
  popup_img:
    "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/ramdankareem2026.webp",
  popup_img_mob:
    "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/ramdankareem20226-2.webp",
  contact_now_btn: "أقساطك & نقاطك",
  last_offers: "اخر العروض",
  exclusive: "حصرياً لك",
  // ** ---------
  // more_clients: "المزيد من العملاء ، تحولات أسرع",
  // ** ---------
  // ** ---------
  //^ income management
  incomeManagement: {
    fisrt_section: {
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/cash-mangement.webp",
      title: "إدارة المحافظ",
      subTitle: "شريكك الموثوق به في سوق رأس مال الدين بمصر!",
      pg: `تتمتع كونتكت بتاريخ طويل وناجح في سوق رأس مال الدين (DCM) بمصر، مما يجعلنا الشريك الرائد في هذا المجال. نحن نستفيد من خبراتنا الواسعة لتقديم مجموعة شاملة من حلول التمويل، مما يساعد الشركات على الازدهار وتحقيق أهدافها المالية في الوقت المطلوب.   
      
      خدماتنا في ادارة رأس مال الدين عديدة وتشمل التوريق، وإصدار الصكوك، و ادارة الاكتتاب، والترويج للأدوات المالية. نضع في أولوياتنا حماية قيمة المحفظة الخاصة بعملائنا من التقلبات السوقية الشديدة، وضمان مستويات سيولة كافية معظم الوقت، وتنويع الأدوات المالية، ومصدر الدين، والمدة، وتحقيق عوائد تنافسية من خلال استراتيجيات مختلفة تحت إدارة مجموعة من المتخصصين في كونتكت.`,
    },
    second_section: {
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/benefits.webp",
      title: "أهم الإنجازات",
      pg: `كونتكت كانت ولازالت رائدةً في مجال ادارة رأس مال الدين في مصر منذ عام 2005. لقد قمنا بترتيب وإصدار أكثر من 26 مليار جنيه مصري كأدوات دين، بما في ذلك أول إصدار للتوريق بالسوق المصري. كما أننا أول جهة مُرخصة مُصدرة للصكوك في السوق المصرية، حيث نقدم حلول تمويل متوافقة مع أحكام الشريعة الإسلامية.
     
      كما قامت كونتكت بإصدار أول سند توريق عقاري في السوق عام 2015، وتمكنت من أن تكون الجهة الرائدة في إصدار صكوك المضاربة في عام 2021. كما أصدرت "كونتكت" أول سند تمويل استهلاكي في عام 2022 بأعلى تصنيف في السوق.`,
    },
    third_section: {
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/3.png",
      title: "باختيارك كونتكت كشريك استراتيجي في سوق رأس مال الدين، ستستفيد من",
      list: [
        "خبرتنا الواسعة والعميقة في مجال سوق رأس مال الدين",
        "علاقاتنا القوية مع الجهات التنظيمية ووكالات التصنيف والمستثمرين وغيرهم من المشاركين في السوق وصُناعه",
        "حلولنا المبتكرة والمخصصة التي تلبي احتياجاتك المالية الخاصة بشركتك",
        "أسعارنا التنافسية وخيارات الدفع المرنة",
        "فريقنا المحترف الذي يقدم الاستشارات والتوجيهات عندما تحتاج",
      ],
    },
    outro:
      "تواصل معنا اليوم لنتمكن من مساعدتك والرد على استفساراتك فيما يخص خدمات إدارة سوق رأس مال الدين.",
  },
  //^ income trading
  incomeTrading: {
    fisrt_section: {
      title: "أدوات الدخل الثابت",
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/ss.webp",
    },
    second_section: {
      first_title: "التوريق",
      fisrt_subtitle: "خبرة تصنع الفارق",
      fisrt_pg: `يعتبر التوريق هو أحد أبرز أدوات إدارة وهيكلة الدين شيوعاً حيث يهدف الي تحويل التحصيلات و الإيرادات الى استثمارات. 
      
      إن اختيار التوريق كهيكلة للدين له مزايا متعددة مثل تعزيز التصنيف الائتماني للأصول الأساسية ، الادخار الضريبي، وانخفاض تكلفة الاستثمار ، والتمويل الإضافي خارج الميزانية العمومية ، ومصدر السيولة النقدية
      
      منذ عام 2005، أصبحت كونتكت شريكًا موثوقًا به في مجال التوريق، حيث نقدم الدعم لشركائنا وعملائنا طوال الوقت. بفضل خبرتنا الواسعة وفهمنا للسوق المصري، نقوم بتخصيص وإيجاد حلول تناسب احتياجات شركتك، ونساعدك على تجاوز تعقيدات التوريق لتحقيق أهدافك المالية في الوقت المطلوب.`,
      second_title: "الصكوك",
      second_subtitle: "متوافقة مع مبادئ الشريعة",
      second_pg: `الصكوك هي أوراق مالية قائمة على الأصول تمثل حصصاً مجمعة وغير مجزأة من الملكية و / أو الحقوق في أصل ملموس من حيث صلتها بمشروع معين أو نشاط استثماري محدد خارج الميزانية العمومية عبر منشآت أعمال ذات غرض واحد  SPV وطويلة الأجل. 

      إمكانية وجود قاعدة عريضة ومتنوعة من الاستثمارات لتكوين هيكل مرن و تشمل على المضاربة والمشاركة والإجارة والمرابحة.

      نحن نقدم خدمات شاملة لإصدار الصكوك في مصر، مما يضمن تلبية احتياجاتك من البداية إلى النهاية.`,
    },
  },

  //^ investment fund

  // ** ---------
  download: "حمل التطبيق",
  direction: "rtl",
  textAlign: "right",
  contact_us_title: "نود أن نستمع إليك!",
  formMsg: "تم ارسال الطلب بنجاح",
  formMsgFail: "فشل ارسال الطلب",
  referralCodeErrorMsg: "يرجى التحقق من كود الدعوة قبل المتابعة في التقديم.",
  clipboardMsg: "تم نسخ الرابط بنجاح",
  subscribeMsg: "تم الاشتراك بنجاح",
  subscribeFailMsg: "فشل الاشتراك",
  insurance_companies_title: "خدمات التأمين للشركات",
  insuranceFeatures_companies: [
    "تأمين السيارات للأفراد والشركات",
    " تأمين الحوادث المتنوعة والمسئوليات",
    " تأمين الممتلكات",
    " التأمينات الهندسية",
    "التأمين البحري والداخلي للبضائع",
    "تأمين طبي",
    "استثمار وادخار",
  ],
  calcTitle: "احسب قسطك",
  purpose: "خطة التمويل",
  purpose2: "غرض التمويل",
  calc_packages: {
    consumer_finance: [{ packageId: 408, title: "كريدي تيك" }],
  },
  general: {
    gifs: { hi: "/gif/hi-ar.gif", calculationg: "/gif/calculating-ar.gif" },
    popup:
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/popup-ar.png",
    menu: {
      about_us: "نبذة عنا",
      blog: "المدونات",
      careers: "وظائف",
      our_brand: "شركات المجموعة",
      contact_us: "اتصل بنا",
      contact_uae: "كونتكت الامارات",
      investor_relations: "علاقات المستثمرين",
      sustainability: "الاستدامة",
      why_contact: "ليه كونتكت ؟",
      payment_channels: "ازاي تدفع قسطك؟",
    },
    reviewTitle: "آراء العملاء",
    reviewSubTitle: "ماذا يقول العملاء عننا؟",
  },
  logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/logo-ar.png",

  main_nav: {
    individuals: "أفراد",
    companies: "شركات",
    investors: "مستثمرين",
    lang: "En",
  },
  secondary_nav: {
    financial_services: "خدمات تمويلية",
    insurance_services: "خدمات تأمينية",
    contact_uae: "كونتكت الامارات",
    contact_now: "كونتكت تسوق",
    about_contact: "عن كونتكت",
    about_contact_dropdown: [
      {
        url: "/about",
        color: colors.ratty,
        img: "/sideDrawer/About_Us_icon.svg",
        title: "نبذة عنا",
      },
      {
        url: "/our-brands",
        color: colors.ratty,
        img: "/sideDrawer/our_brands_icon.svg",
        title: "شركات المجموعة",
      },
      {
        url: "/contact-us",
        color: colors.ratty,
        img: "/sideDrawer/Contact_us_Icon.svg",
        title: "اتصل بنا",
      },
    ],
    payment_channels: "ازاي تدفع قسطك؟",
    blog: "المدونات",
    careers: "وظائف",
    investor_relations: "علاقات المستثمرين",
    sustainability: "الاستدامة",
    e_payments: "مدفوعات الكترونية",
    why_contact: "ليه كونتكت ؟",
    clients_program: "كتالوج كونتكت",
    // investment_and_savings: "استثمار وادخار",
    offers: "العروض",
    branches_location: "أماكن الفروع",
    login: "تسجيل الدخول",
    download_app: "حمل التطبيق",
    insurance_services_dropdown: [
      {
        url: "/products/insurance",
        color: colors.ratty,
        img: "/services/contact-insurance-ar.png",
        title: "وساطة تأمينية",
      },
      {
        url: "/sarwa-life",
        color: colors.ratty,
        img: "/services/sarwa-life-ar.png",
        title: "ثروة لتأمينات الحياة",
      },
      {
        url: "/sarwa-insurance",
        color: colors.ratty,
        img: "/services/sarwa-insurance-ar.png",
        title: "ثروة للتأمين",
      },
    ],
  },
  footer: {
    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/subscribe.svg",
      subscribe_now: "سيب لنا إيميل نعرف نوصلّك عليه بكل جديد وعروض متتفوتش!",
      in_email_service: "في خدمة البريد الالكتروني",
      enter_email: "info@gmail.com",
      button: "إشترك",
      loading: "جاري الارسال ...",
    },
    section_b: {
      financial_services: "خدمات تمويلية",
      insurance_services: "خدمات تأمينية",
      for_individuals: "للأفراد",
      Terms_and_Conditions: "الشروط و الأحكام",

      list1: [
        { id: "1", name: "تمويل السيارات", url: "/products/auto" },
        { id: "2", name: "تمويل النقل", url: "/products/trucks" },
        { id: "3", name: "تسوق", url: "/products/contact-now" },
        { id: "4", name: "تمويل التعليم", url: "/products/education" },
        { id: "5", name: "تمويل اشتراكات الاندية", url: "/products/clubs" },
        { id: "6", name: "تمويل الصيانة", url: "/products/maintainance" },
        { id: "8", name: "تمويل عقاري", url: "/products/mortgage" },
        {
          id: "9",
          name: "تمويل الدراجات النارية",
          url: "/products/motorcycles",
        },
        { id: "10", name: "التمويل الأخضر", url: "/products/green-finance" },
        { id: "11", name: "تخصيم", url: "/products-bussiness/factoring" },
        { id: "12", name: "تأجير تمويلي", url: "/products-bussiness/leasing" },
        {
          id: "13",
          name: "تمويل التصميم و التشطيب",
          url: "/products/home-interior",
        },
        { id: "14", name: "تمويل فرش البيت", url: "/products/home-furniture" },
        {
          id: "15",
          name: "تمويل مركبات ومعدات الرياضات المائية",
          url: "/products/watercraft",
        },
      ],
      list2: [
        { name: "وساطة تأمينية", url: "/products/insurance" },
        {
          name: "ثروة لتأمينات الحياة",
          url: "/sarwa-life",
        },
        {
          name: "ثروة للتأمين",
          url: "/sarwa-insurance",
        },
      ],
      list3: [{ name: "مدفوعات الكترونية", url: "/e-payment" }],
      for_business: "للشركات",
      for_business_list: [{ name: "برامج كونتكت", url: "/referral-program" }],
      contact: "عن كونتكت",
      contact_list: [
        { name: "عنا", url: "/about" },
        { name: "شركاتنا", url: "/our-brands" },
        { name: "ليه كونتكت ؟", url: "/why-contact" },
        { name: "وظائفنا", url: "/careers" },
        { name: "كونتكت الإمارات", url: "/contact-uae" },

        {
          name: " علاقات المستثمرين",
          url: "https://investorrelations.contact.eg/ar",
        },
        { name: "الاستدامة", url: "/sustainability" },
        { name: "المدونات", url: "/blogs" },
        { name: "أخبارنا", url: "/media" },
      ],
      contact_us: "تواصل معنا",
      contact_us_list: [
        {
          name: "كتالوج كونتكت",
          url: `https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Contact-Catalogue.pdf`,
        },
        { name: "فروعنا", url: "/our-branches" },
        { name: "الخط الساخن: 16177", url: "" },
        { name: "ازاي تدفع قسطك؟", url: "/payment-channels" },
      ],
      privacy: "السياسات",
      privacy_list: [{ name: "سياسة الخصوصية", url: "/privacy-policy.pdf" }],
      protection_guide: "دليل حماية المستهلك",
      protection_guide_list: [
        {
          name: "دليل 1",
          url: "https://fra.gov.eg/%D8%AF%D9%84%D9%8A%D9%84-%D8%AD%D9%85%D8%A7%D9%8A%D8%A9-%D8%A7%D9%84%D9%85%D8%AA%D8%B9%D8%A7%D9%85%D9%84%D9%8A%D9%86-%D9%81%D9%8A-%D8%A7%D9%84%D9%82%D8%B7%D8%A7%D8%B9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/",
        },
        {
          name: "دليل 2",
          url: `${process.env.NEXT_PUBLIC_SITE_URL}كتاب دورى رقم (4) .pdf`,
        },
      ],
    },
    section_c: {
      download_app: "حمل تطبيق كونتكت",
      img1: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/google-play-ar.png",
      img2: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/app-store-ar.png",
      img3: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/huawei-store-ar.png",
    },
    section_d: {
      copy_right: "جميع الحقوق محفوظة لكونتكت ",
    },
  },
  form_labels: {
    title: "شبكة التجار",
    full_name: "الإسم بالكامل",
    last_name: "اسم العائلة",
    email_adress: "البريد الالكتروني",
    phone_number: "رقم الموبايل",
    national_id: "الرقم القومي",
    governorate: "المحافظة",
    g_placeholder: "اختر المحافظة",
    referralCode: "كود الدعوة",
    city: "المدينة",
    category: "الفئة",
    area: "المنطقة",
    country: "الدولة",
    country_placeholder: "اختر الدولة ",
    case1: "من فضلك اختر على الأقل فئة ومدينة",
    case2: "لا يوجد تجار",
    cat_placeholder: "اختر الفئة",
    city_placeholder: "اختر المدينة",
    area_placeholder: "اختر المنطقة",
    a_placeholder: "اختر المنطقة",
    car_type: "حالة السيارة",
    car_placeholder: "اختر حالة السيارة",
    car_price: "ثمن السيارة",
    products: "المنتجات",
    products_placeholder: "اختر منتج",
    offers_placeholder: "اختر العرض",
    offers_label: "العروض",
    mortgage_type: "نوع التمويل",
    POS_Placeholder: "اختر نقاط البيع",
    submit: "أرسل طلبك",
    // =======
    subject: "الموضوع",
    message: "كيف يمكننا مساعدتك؟",
    job: "الوظيفة المقدم عليها",
    resume: "السيرة الذاتية",
    resume_des: "برجاء رفع الرابط الخاص بالسيرة الذاتية",
    passport_copy: "صورة من جواز السفر ساري",
    work_permit: "صورة من اقامة العمل",
    hr_letter: "خطاب HR من جهة العمل",
    bank_statement: "كشف حساب بنكي",
    EgyptAddress: "  عنوان إقامة داخل مصر",
    noFileChosen: "لا يوجد ملف مختار",
    chooseFile: "حدد الملف",
    terms:
      "بالضغط على هذا المربع، أوافق على منح شركة كونتكت للتمويل الحق والموافقة على الكشف عن البيانات والمعلومات المتعلقة بى او التسهيل الائتماني والالتزامات المتعلقة بذلك وأى تقصير إن وجد الى الشركة المصرية للإستعلام الائتمانى (I-Score)، ويتضمن ذلك إستخراج تقرير الإستعلام  الخاص بى والمُطلوب للموافقة على الطلب المُقدم. بالاضافة الى ذلك، أقر بأننى أقبل اجراءات الاستعلام عنى من جانب موظفى شركة كونتكت للتمويل دون اعتراض مني\u202B.\u202C",
    enterPhoneFirst: "الرجاء إدخال رقم هاتفك اولا",
    Disclaimer:
      " للحصول على عملية موافقة اسرع , يرجى تحميل جميع المستندات ذات الصلة",
    Disclaimer2: "للحصول على عملية موافقة أسرع",
    apply: "قدم للوظيفة",
    showmore: "عرض المزيد",
    optional: "اختياري",
    edit: "تعديل",
    save: "حفظ التغيرات ",
    cancel: "الغاء",
    secondPhone: "رقم الهاتف الإضافي",
    additionalP: "رقم شخص يمكن الاتصال به   ",
    additionalN: "اسم الشخص الموثوق ",
    preferredCallingTime: "الوقت المناسب للتواصل",
    time_placholder: "إختر الوقت",
    submit_form: "أرسل طلبك",
    request_service: "اطلب الخدمة",
  },
  governorates: [
    {
      id: "1",
      governorate_name: "القاهرة",
    },
    { id: "2", governorate_name: "الجيزة" },
    {
      id: "3",
      governorate_name: "الأسكندرية",
    },
    {
      id: "4",
      governorate_name: "الدقهلية",
    },
    {
      id: "5",
      governorate_name: "البحر الأحمر",
    },
    {
      id: "6",
      governorate_name: "البحيرة",
    },
    {
      id: "7",
      governorate_name: "الفيوم",
    },
    {
      id: "8",
      governorate_name: "الغربية",
    },
    {
      id: "9",
      governorate_name: "الإسماعلية",
    },
    {
      id: "10",
      governorate_name: "المنوفية",
    },
    {
      id: "11",
      governorate_name: "المنيا",
    },
    {
      id: "12",
      governorate_name: "القليوبية",
    },
    {
      id: "13",
      governorate_name: "الوادي الجديد",
    },
    {
      id: "14",
      governorate_name: "السويس",
    },
    {
      id: "15",
      governorate_name: "اسوان",
    },
    {
      id: "16",
      governorate_name: "اسيوط",
    },
    {
      id: "17",
      governorate_name: "بني سويف",
    },
    {
      id: "18",
      governorate_name: "بورسعيد",
    },
    {
      id: "19",
      governorate_name: "دمياط",
    },
    {
      id: "20",
      governorate_name: "الشرقية",
    },
    {
      id: "21",
      governorate_name: "جنوب سيناء",
    },
    {
      id: "22",
      governorate_name: "كفر الشيخ",
    },
    {
      id: "23",
      governorate_name: "مطروح",
    },
    {
      id: "24",
      governorate_name: "الأقصر",
    },
    { id: "25", governorate_name: "قنا" },
    {
      id: "26",
      governorate_name: "شمال سيناء",
    },
    {
      id: "27",
      governorate_name: "سوهاج",
    },
  ],
  country: [
    {
      id: "مصر",
      country_name: "مصر",
      phoneCode: "+٠٢",
      flag: "EG",
      icon: cifEg,
    },
    {
      id: "الامارات",
      country_name: "الامارات",
      phoneCode: "+٩٧١",
      flag: "AE",
      icon: cifAe,
    },
  ],
  car_type: [
    {
      id: "1",
      value: "جديد",
    },
    { id: "2", value: "مستعمل" },
  ],
  preferredCallingTime: [
    "من ٩:٠٠ صباحًا إلى ١٢:٠٠ ظهرًا",
    "من ١٢:٠٠ ظهرًا إلى ٣:٠٠ مساءً",
    "من ٣:٠٠ مساءً إلى ٦:٠٠ مساءً",
    "من ٦:٠٠ مساءً إلى ٩:٠٠ مساءً",
  ],
  mortgage_type: [
    {
      id: "1",
      value: "تمويل المنزل",
    },
    { id: "2", value: "إعادة تمويل المنزل" },
  ],
  home_page: {
    slides: [
      {
        bgColor: "#EAEAEA",
        bgImage:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bg-banner-ar.svg",
        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-ar-white.png",
        alt: "قسط مع كونتكت",
        text: `
        <h1>
        تمويل وتأمين في مكان واحد
        </h1>
        `,
        textColor: colors.white,
        button: "تصفح المنتجات",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/one-shop-banner.webp",
        link: "/#all-products",
      },

      {
        bgColor: "#EAEAEA",
        bgImage:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bg-banner-ar.svg",

        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-brokerage-ar-light.png",

        text: "حمل التطبيق واستمتع بكل مزايا التأمين وانت في مكانك",
        textColor: colors.white,

        button: "اطلب الخدمة",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brokrage-banner.webp ",
        alt: "الوساطة التأمينيه",
        link: "/products/insurance",
        app: {
          google_play_link:
            "https://play.google.com/store/apps/details?id=com.insuranceBrokerage&hl=ar",
          app_store_link:
            "https://apps.apple.com/eg/app/insurance-brokerage/id6445921286",
          qr_code:
            "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance_brokerage_qr_code.webp",
        },
      },
      {
        bgColor: "#EAEAEA",
        bgImage:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bg-banner-ar.svg",
        textColor: colors.white,
        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-logo-ar.png",
        text: "بنقربلك في كل محافظة في مصر",
        button: "ابحث عن أقرب فرع",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/cover_img_22-ar.png",
        alt: "فروع كونتكت",
        link: "/our-branches",
      },
    ],
    sec_navigation: [
      { title: "فروعنا", url: "/our-branches" },
      { title: "المدونات", url: "/blogs" },
      {
        title: "كتالوج كونتكت",
        url: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Contact-Catalogue.pdf",
      },
      { title: "العروض", url: "/our-offers" },
    ],
    services_title: "خدماتنا",
    products_title: "منتجاتنا",

    products: [
      {
        optionId: "1",
        title1: "",
        title2: "تمويل السيارات",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cars-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cars-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/auto",
        value: "Auto",
        alt: "auto background",
      },
      {
        optionId: "1",
        title1: "",
        title2: "تمويل الدراجات النارية",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/motorcycle-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/motorcycle-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/motorcycles",
        value: "Motorcycles",
        alt: "mortgage background",
      },
      {
        optionId: "1",
        title1: "",
        title2: "تمويل النقل",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/trucks-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/trucks-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/trucks",
        value: "Trucks",
        alt: "trucks background",
      },
      {
        optionId: "1",
        title1: "",
        title2: "تمويل المركبات المائية",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/watercraft",
        value: "Watercrafts",
        alt: "watercraft background",
      },
      {
        optionId: "2",
        title1: "",
        title2: "تمويل عقاري",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/mortgage",
        value: "Mortgage",
        alt: "mortgage background",
      },
      {
        optionId: "2",
        title1: "",
        title2: "تمويل التشطيب",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/finishing-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/finishing-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/home-interior",
        value: "Homes",
        alt: "home interior background",
      },
      {
        optionId: "2",
        title1: "",
        title2: "تمويل فرش البيت",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/furniture-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/furniture-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/home-furniture",
        value: "HomeFurniture",
        alt: "furniture background",
      },
      {
        optionId: "5",
        title1: "",
        title2: "تمويل التعليم",
        img: "/pages/schools.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/schools-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "5",
        title1: "",
        title2: "اشتراكات الاندية",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubs-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubs-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/clubs",
        value: "Clubs",
        alt: "clubs background",
      },
      {
        optionId: "5",
        title1: "",
        title2: "تمويل تسوق",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cart.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cart-small.webp",
        bgcolor: "#fff",
        url: "/products/contact-now",
        value: "shopping",
        alt: "shopping background",
      },
      {
        optionId: "2",
        title1: "",
        title2: "تمويل الصيانة",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintainance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintainance-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/maintainance",
        value: "Maintenance",
        alt: "maintenance background",
      },

      {
        optionId: "3",
        title1: "",
        title2: "وساطة تامينية",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-cover-small-ar.webp",
        bgcolor: "#fff",
        url: "/products/insurance",
        value: "Brokerage",
        alt: "insurance background",
      },
      {
        optionId: "3",
        title2: "ثروة لتأمينات الحياة",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brand-sarwa-life.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-life-small-ar.webp",
        bgcolor: "#fff",
        url: "/sarwa-life",
        value: "Life",
        alt: "insurance background",
      },
      {
        optionId: "3",
        title2: "ثروة للتأمين",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brand-sarwa-insurance.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-insurance-small-ar.png",
        bgcolor: "#fff",
        url: "/sarwa-insurance",
        value: "Insurance",
        alt: "insurance background",
      },

      {
        optionId: "4",
        title1: "",
        title2: "حضانة",
        img: "/pages/nursery.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/nursery-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "4",
        title1: "",
        title2: "مدارس",
        img: "/pages/schools.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/schools-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "4",
        title1: "",
        title2: "جامعات",
        img: "/pages/universities.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/universities-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "4",
        title1: "",
        title2: "دراسات عليا وكورسات",
        img: "/pages/postgraduate.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/postgraduate-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "6",
        title2: "السيارات الكهربائية",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-finance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-car-small.webp",
        bgcolor: "#fff",
        url: "/products/auto",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "6",
        title2: "ألواح الطاقة الشمسية",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-finance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-energy-small.webp",
        bgcolor: "#fff",
        url: "/products/green-finance",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "6",
        title2: "الصوب الزراعية",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-finance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-house-small.webp",
        bgcolor: "#fff",
        url: "/products/green-finance",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "6",
        title2: "نظم الري",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-finance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-watering-small.png",
        bgcolor: "#fff",
        url: "/products/green-finance",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "7",
        title2: "السفر و السياحة",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/travel+and+tourism+640x640.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/travel+and+tourism+640x640.webp",
        bgcolor: "#fff",
        url: "/products/travel-and-tourism",
        value: "Manasik",
        alt: "manasik",
      },

      // *********
      {
        title1: "",
        title2: "تمويل التخصيم",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/factoring-cover.webp",
        bgcolor: "#bf6340",
        url: "/products-bussiness/factoring",
        value: "Factoring",
        alt: "factoring background",
      },
      {
        title1: "",
        title2: "تأجير تمويلي",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/leasing-cover.webp",
        bgcolor: "#4aa2a6",
        url: "/products-bussiness/leasing",
        value: "Leasing",
        alt: "leasing background",
      },
      // *******
    ],
    bos: {
      title1: "دفع الفواتير",
      // title2: "فواتيرك",
      subtitle: "حل الدفع الشامل!",
      body1:
        "اتخلص من مشاكل الفواتير الكتير والطوابير الطويلة مع كونتكت باي، حل الدفع المُبتكر من كونتكت!",
      body2: [
        "مصاريف المدارس والجامعات",
        "فواتير الكهرباء",
        "فواتير الغاز",
        "فواتير التليفون الأرضي",
        "فواتير المياه",
        "فواتير وشحن المحمول",
        "تذاكر وسائل النقل",
        "اشتراك الإنترنت",
        "اشتراك القنوات التلفزيونية",
        "الأقساط التأمينية",
        "التبرعات الخيرية",
        "اشتراكات الأندية",
      ],
      WithContactPay_list: {
        title: "إيه اللي تقدر تدفعه مع كونتكت باي؟",
        list: [
          "فواتير الكهرباء",
          "فواتير الغاز ",
          "فواتير المياه ",
          "فواتير التليفون الأرضي",
          "فواتير وشحن المحمول ",
          "اشتراك الإنترنت",
          "تذاكر وسائل النقل ",
          "الأقساط التأمينية",
          "التبرعات الخيرية",
          "اشتراكات الأندية",
          "مصاريف المدارس والجامعات",
        ],
      },
      benefits: {
        title: "المميزات",
        list: [
          "سرعة وسهولة: كونتكت باي بتخليك تدفع كل مصاريفك بسرعة وسهولة.",
          "معاملات مالية آمنة يمكنك الاعتماد عليها: اطمن لأن معاملاتك محمية بإجراءات الأمان المتقدمة من كونتكت.",
          "حل شامل: متلخبط بين منصات مدفوعات كتير، مع كونتكت باي هتدفع كل فواتيرك بسهولة وفي مكان واحد.",
        ],
      },
      outro: (
        <p>
          كونتكت باي طريقة الكترونية سهلة وأكتر كفاءة لإدارة مدفوعاتك. اتصل بنا
          أو زور أي فرع من فروعنا عشان تعرف أكتر وتدفع اى مصاريف أو فواتير عن
          طريق كونتكت باي حل الدفع الذكى.
          <p style={{ paddingTop: "16px" }}>
            {" "}
            <a
              target="_blank"
              style={{ color: "#F18222", fontWeight: "600" }}
              href={userAgent(
                "https://apps.apple.com/us/app/contactnow-%D9%83%D9%88%D9%86%D8%AA%D9%83%D8%AA/id1544159088",
                "https://play.google.com/store/apps/details?id=eg.contact",
              )}
            >
              حمل التطبيق دلوقتي!{" "}
            </a>{" "}
          </p>
        </p>
      ),
    },
    services: {
      A: [
        {
          id: "1",
          url: "/products/auto",
          color: colors.blue,
          img: "/services/car.svg",
          title: "تمويل السيارات",
          description:
            "لو عايز تشتري عربية جديدة أو مستعملة، كونتكت بتوفرلك حلول تمويلية متميزة لجميع الماركات ",
        },
        {
          id: "7",
          url: "/products/motorcycles",
          color: "#DD6F5A",
          img: "/services/motorcycle.svg",
          title: "تمويل الدراجات النارية",
        },
        {
          url: "/products/trucks",
          id: "2",
          color: colors.dark_red,
          img: "/services/lorry.svg",
          title: "تمويل النقل",
          description:
            "سواء محتاج نقل تقيل أو خفيف كونتكت هتقسطلك جميع أنواع الشاحنات الجديدة والمستعملة والاستيراد",
        },
        {
          id: "15",
          url: "/products/watercraft",
          color: "#27A9E1",
          img: "/services/watercraft.svg",
          title: "تمويل مركبات ومعدات الرياضات المائية",
          description:
            "لو عايز تفرش وتجهز بيتك على مزاجك ومن أي مكان نفسك فيه، كونتكت هتسهلك المشوار",
        },
        {
          id: "9",
          url: "/products/mortgage",
          color: colors.dark_petroli,
          img: "/services/house.svg",
          title: "تمويل عقاري",
          description:
            'احصل على تمويل بيت أحلامك بأسهل وأسرع الإجراءات من خلال نظام "تمويل بيتك"',
        },
        {
          url: "/products/home-interior",
          id: "14",
          color: colors.dark_brown,
          img: "/services/design.svg",
          title: "تمويل التصميم و التشطيب",
          description:
            "لو عايز تصمم وتشطب بيتك على مزاجك من خلال أفضل شركات التصميم الداخلي والديكور في مصر، ",
        },
        {
          id: "13",
          url: "/products/home-furniture",
          color: "#5E7EB5",
          img: "/services/home-furniture.svg",
          title: "تمويل فرش البيت",
          description:
            "لو عايز تفرش وتجهز بيتك على مزاجك ومن أي مكان نفسك فيه، كونتكت هتسهلك المشوار",
        },
      ],
      B: [
        {
          url: "/products/education",
          id: "4",
          color: colors.green,
          img: "/services/education.svg",
          title: "تمويل التعليم",
          description:
            "نفسك في مستقبل أفضل ليك ولأولادك، كونتكت هتساعدك وهتكون معاك طول مشوار التعليم",
        },
        {
          url: "/products/clubs",
          id: "5",
          color: colors.dark_petroli,
          img: "/services/clubs.svg",
          title: "تمويل اشتراكات الاندية",
          description:
            "نفسك تُنمى مهارات أولادك وتساعدهم يمارسوا الرياضة اللي بيحبوها، كونتكت هتقسطلك اشتراك ",
        },
        {
          url: "/products/contact-now",
          id: "3",

          color: colors.dark_violet,
          img: "/services/cart.svg",
          title: "تسوق",
          description: "لو نفسك تشتري في أي وقت براحتك، كونتكت هتسهل حياتك",
        },
        {
          id: "6",
          url: "/products/maintainance",
          color: "#DB8539",
          img: "/services/maintainance.svg",
          title: "تمويل الصيانة",
          description:
            "سواء كنت عايز تصّلّح عربيتك، تجدد بيتك، أو تعمل صيانة لأي حاجة، احنا عارفين إن الصيانة ممكن تكلّف كتير وتاخُد وقت. عشان كده كونتكت موجودة عشان تساعدك في كل احتياجات الصيانة بتاعتك. كونتكت بتقدملك حلول تمويل مبتكرة لأي صيانة، من خلال تمويل الصيانة هتقدر تستعين بأحسن عمال الصيانة في مصر، وتقسط بعدين بأقساط مريحة وسهلة.",
        },
        {
          id: "12",
          url: "/products/green-finance",
          color: colors.light_green,
          img: "/services/green-finance.svg",
          title: "التمويل الأخضر",
          description:
            "لو محتاج تُنمي استثمارك الزراعي، كونتكت بتقدملك التمويل اللازم اللي هيساعدك في تحقيق التنمية ",
        },
        {
          id: "16",
          url: "/products/travel-and-tourism",
          color: "#27A9E1",
          img: "/services/travel-tourism.svg",
          title: "تمويل السياحة و السفر",
        },

        {
          url: "/products-bussiness/factoring",
          id: "10",
          color: colors.dark_brown,
          img: "/services/discount.svg",
          title: "تخصيم",
          description:
            "لو محتاج سيولة نقدية، كونتكت هتدعمك وهتضمنلك تعزيز رأس المال الخاص بشركتك ",
        },
        {
          url: "/products-bussiness/leasing",
          id: "11",
          color: colors.light_petroli,
          img: "/services/rent.svg",
          title: "تأجير تمويلي",
          description:
            "لو عايز تجهز عيادتك الطبية أو تطور أسطول النقل الخاص بشركتك",
        },
      ],
      All: [
        {
          id: "1",
          url: "/products/auto",
          color: colors.blue,
          img: "/services/car.svg",
          title: "تمويل السيارات",
          description:
            "لو عايز تشتري عربية جديدة أو مستعملة، كونتكت بتوفرلك حلول تمويلية متميزة لجميع الماركات ",
        },
        {
          id: "7",
          url: "/products/motorcycles",
          color: "#DD6F5A",
          img: "/services/motorcycle.svg",
          title: "تمويل الدراجات النارية",
        },
        {
          url: "/products/trucks",
          id: "2",
          color: colors.dark_red,
          img: "/services/lorry.svg",
          title: "تمويل النقل",
          description:
            "سواء محتاج نقل تقيل أو خفيف كونتكت هتقسطلك جميع أنواع الشاحنات الجديدة والمستعملة والاستيراد",
        },
        {
          id: "15",
          url: "/products/watercraft",
          color: "#27A9E1",
          img: "/services/watercraft.svg",
          title: "تمويل مركبات ومعدات الرياضات المائية",
          description:
            "لو عايز تفرش وتجهز بيتك على مزاجك ومن أي مكان نفسك فيه، كونتكت هتسهلك المشوار",
        },
        {
          id: "9",
          url: "/products/mortgage",
          color: colors.dark_petroli,
          img: "/services/house.svg",
          title: "تمويل عقاري",
          description:
            'احصل على تمويل بيت أحلامك بأسهل وأسرع الإجراءات من خلال نظام "تمويل بيتك"',
        },
        {
          url: "/products/home-interior",
          id: "14",
          color: colors.dark_brown,
          img: "/services/design.svg",
          title: "تمويل التصميم و التشطيب",
          description:
            "لو عايز تصمم وتشطب بيتك على مزاجك من خلال أفضل شركات التصميم الداخلي والديكور في مصر، ",
        },
        {
          id: "13",
          url: "/products/home-furniture",
          color: "#5E7EB5",
          img: "/services/home-furniture.svg",
          title: "تمويل فرش البيت",
          description:
            "لو عايز تفرش وتجهز بيتك على مزاجك ومن أي مكان نفسك فيه، كونتكت هتسهلك المشوار",
        },
        {
          url: "/products/education",
          id: "4",
          color: colors.green,
          img: "/services/education.svg",
          title: "تمويل التعليم",
          description:
            "نفسك في مستقبل أفضل ليك ولأولادك، كونتكت هتساعدك وهتكون معاك طول مشوار التعليم",
        },
        {
          url: "/products/clubs",
          id: "5",
          color: colors.dark_petroli,
          img: "/services/clubs.svg",
          title: "تمويل اشتراكات الاندية",
          description:
            "نفسك تُنمى مهارات أولادك وتساعدهم يمارسوا الرياضة اللي بيحبوها، كونتكت هتقسطلك اشتراك ",
        },
        {
          url: "/products/contact-now",
          id: "3",

          color: colors.dark_violet,
          img: "/services/cart.svg",
          title: "تسوق",
          description: "لو نفسك تشتري في أي وقت براحتك، كونتكت هتسهل حياتك",
        },
        {
          id: "6",
          url: "/products/maintainance",
          color: "#DB8539",
          img: "/services/maintainance.svg",
          title: "تمويل الصيانة",
          description:
            "سواء كنت عايز تصّلّح عربيتك، تجدد بيتك، أو تعمل صيانة لأي حاجة، احنا عارفين إن الصيانة ممكن تكلّف كتير وتاخُد وقت. عشان كده كونتكت موجودة عشان تساعدك في كل احتياجات الصيانة بتاعتك. كونتكت بتقدملك حلول تمويل مبتكرة لأي صيانة، من خلال تمويل الصيانة هتقدر تستعين بأحسن عمال الصيانة في مصر، وتقسط بعدين بأقساط مريحة وسهلة.",
        },
        {
          id: "12",
          url: "/products/green-finance",
          color: colors.light_green,
          img: "/services/green-finance.svg",
          title: "التمويل الأخضر",
          description:
            "لو محتاج تُنمي استثمارك الزراعي، كونتكت بتقدملك التمويل اللازم اللي هيساعدك في تحقيق التنمية ",
        },
        {
          id: "16",
          url: "/products/travel-and-tourism",
          color: "#27A9E1",
          img: "/services/travel-tourism.svg",
          title: "تمويل السياحة و السفر",
        },

        {
          url: "/products-bussiness/factoring",
          id: "10",
          color: colors.dark_brown,
          img: "/services/discount.svg",
          title: "تخصيم",
          description:
            "لو محتاج سيولة نقدية، كونتكت هتدعمك وهتضمنلك تعزيز رأس المال الخاص بشركتك ",
        },
        {
          url: "/products-bussiness/leasing",
          id: "11",
          color: colors.light_petroli,
          img: "/services/rent.svg",
          title: "تأجير تمويلي",
          description:
            "لو عايز تجهز عيادتك الطبية أو تطور أسطول النقل الخاص بشركتك",
        },
      ],
      C: [
        {
          url: "/referral-program",

          color: colors.blue,
          img: "/services/clients.svg",
          title: "برنامج ترشيح العملاء",
          description:
            "يمكنك ترشيح أصدقاءك والحصول على نقاط مجانية وخصومات حصرية",
          full_description:
            "الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر",
        },
      ],
      D: [
        {
          url: "/referral-program",

          color: colors.blue,
          img: "/services/clients.svg",
          title: "برنامج ترشيح العملاء",
          description:
            "يمكنك ترشيح أصدقاءك والحصول على نقاط مجانية وخصومات حصرية",
          full_description:
            "الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر",
        },
      ],
    },
    news_title: "أخبارنا",
    news_button1: "اقرأ المزيد",
    news_button2: "المزيد",
    news: [
      {
        id: "1",
        img: "/news/news1.png",
        title: "كونتكت تطلق منتج رقمي لتأمين السيارات",
        description:
          "كونتكت المالية القابضة تعلن اليوم عن إطلاق منتج رقمي بالكامل للتأمين التكميلى للسيارات في مصر. يتوفر المنتج من خلال منصة كونتكت كارز دوت كوم وشركة ثروة للتأمين وشركة كونتكت ...",
      },
      {
        id: "2",
        img: "/news/news2.png",
        title:
          "«شطبلي» توقع اتفاقية شراكة مع «كونتكت» لإتاحة برامج تمويل مبتكرة",
        description:
          "وقّعت شركة «شطبلي»، صاحبة أول منصة إلكترونية متخصصة في أعمال تصميم وتنفيذ أعمال الديكورات والتشطيبات، اتفاقية شراكة مع شركة كونتكت للتمويل ...",
      },
      {
        id: "3",
        img: "/news/news3.png",
        title: "كونتكت توقع برنامج تمويل فريد من نوعه في مصر مع كابيتر",
        description:
          "وقعت كونتكت المالية القابضة (CNFN)، الشركة الرائدة في مجال الخدمات المالية غير مصرفية في مصر، من خلال شركة كونتكت للتخصيم، أحد ...",
      },
    ],
    payment_channels: {
      title: "ازاي تدفع قسطك مع كونتكت",
      titleMob: "ازاي تدفع قسطك؟",
      description: `
  <p>خلّي تجربة الدفع أسهل من أي وقت!</p>
  <p>
    مع كونتكت تقدر تسدد أقساطك أونلاين، من أقرب نقطة دفع، أو من خلال فروعنا — 
    كل دا بخطوات بسيطة بتوفر عليك وقتك.<br />
    تفضل بزيارة 
    <a href="/our-branches" style="color:#2D317F; font-weight:600; text-decoration:none;">
      اقرب فرع
    </a>
    إليك أو أتمم مدفوعاتك بسرعة وأمان عبر تطبيق 
    <a
  href="https://onelink.to/frpjkg"
  target="_blank"
  rel="noopener noreferrer"
  style="color:#2D317F; font-weight:600; text-decoration:none;"
>
  كونتكت ناو
</a>
  </p>
`,
      button: "أعرف المزيد",
      channels_logos: [
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/contact_now.svg",
          width: "80px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bee_basata.svg",
          width: "36px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/instapay.svg",
          width: "69px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/alahly_momkn.svg",
          width: "100px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/superpay.svg",
          width: "120px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/opay.svg",
          width: "116px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/fawry.svg",
          width: "118px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/damen.svg",
          width: "95px",
        },
      ],
    },
  },

  calc: {
    monthlyAmount: " قيمة القسط الشهري",
    priceCar: "قيمة التمويل",
    preAmount: "المقدم",
    plan: "الخطة",
    plan: "الخطة",
    egyptianPound: "جنيه",
    duration: "المدة",
    month6: "6 شهور",
    months: "شهور",
    years: "{{count}} سنة",
    year1: "1 سنة",
    year2: "2 سنة",
    year3: "3 سنة",
    year4: "4 سنة",
    year5: "5 سنة",
    year6: "6 سنة",
    year7: "7 سنة",
    year8: "8 سنة",
    year9: "9 سنة",
    year10: "10 سنة",
    plan1: "البرنامج الإقتصادي",
    plan2: "البرنامج المرن",
    amount: "مبلغ التمويل",
    downPaymentRange: "يجب ان تكون القيمة بين {{min}} و {{max}}",
  },

  investment: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/investement.png",
      color: "#5686A3",
      title1: "كونتكت كل يوم للاستثمار والادخار",
      title2: "شريك استثمارك اليومي ",
      description: `كونتكت "كل يوم" طريقة بسيطة وآمنة ومليانة بالمكاسب تقدر من خلالها تكتر فلوسك كل يوم. باستثمار سهل وفرصه لكل الناس عشان تحقق طموحاتها المالية. استفيد من محفظة متنوعة من الأصول ، وتضمنلك عوائد مستقرة مع الحفاظ على رأس مالك.`,
    },
    outro: `كونتكت "كل يوم" أكتر من مجرد استثمار، هو التزام لتأمين مستقبلك المالي، انضم لينا وابدأ رحلتك الاستثمارية مع العوائد اليومية.
    `,
    subOutro: `استثمر في بكرة مع كونتكت "كل يوم"!`,
  },

  featureSection: [
    {
      id: "1",
      delay: "0",
      img: "/home-services/finance.svg",
      title: "تمويل",
      text: " خدمات تمويلية متعددة تناسب جميع احتياجاتك",
    },
    {
      id: "2",
      delay: "150",
      img: "/home-services/insurance.svg",
      title: "تأمين",
      text: "مكان واحد لكل الخدمات التأمينية",
    },
    {
      id: "3",
      delay: "300",
      img: "/home-services/invetment-new.svg",
      title: "استثمار وادخار",
      text: "شريك استثمارك اليومي ",
    },
    {
      id: "4",
      delay: "350",
      img: "/home-services/payment.svg",
      title: "مدفوعات الكترونية",
      text: "أدفع فواتيرك وأقساطك وانت في مكانك",
    },
  ],
  stepsFeature: [
    {
      id: "1",
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/step-1-ar.webp",
      title: "موافقة فورية",
      subTitle: "ميزة",
      text: "موافقه فورية على الحد الائتماني",
    },
    {
      id: "2",
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/step-2-ar.webp",
      title: "زيادة الحد الائتماني",
      subTitle: "ميزة",
      text: "طلب زيادة الحد الائتماني",
    },
    {
      id: "3",
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/step-3-ar.webp",
      title: "ادفع فواتيرك",
      subTitle: "ميزة",
      text: "دفع الأقساط والفواتير",
    },
    {
      id: "4",
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/step-4-ar.webp",
      title: "العروض والمنتجات",
      subTitle: "ميزة",
      text: "متابعة أحدث العروض والمنتجات",
    },
    {
      id: "5",
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/step-5-ar.webp",
      title: "شبكة التجار والخدمات",
      subTitle: "ميزة",
      text: "التعرف على شبكة التجار والخدمات",
    },
  ],
  stepsFeature_business: [
    {
      id: "1",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-step-1-ar.webp",
      title: "إستشارات طبية",
      subTitle: "ميزة",
      text: "استشارات طبية فورية، وايضاً الإستفادة من توجيهات الأطباء في الحلات الطارئة من خلال التطبيق.",
    },
    {
      id: "2",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-step-2-ar.webp",
      title: "مواعيد أدويتك",
      subTitle: "ميزة",
      text: "تذكيرك بمواعيد أدويتك في الاوقات والجرعات المحددة بتنبيهات على التطبيق لتجنب نسيان أوقات تناول الدواء ولتحسين صحتك العامة.",
    },
    {
      id: "3",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-step-3-ar.webp",
      title: "الصحة البدنية",
      subTitle: "feature",
      text: "مقالات متنوعة عن الصحة البدنية تساعدك على تبني نمط حياه صحي وتجنب عادات يومية خاطئة لحياه صحية أفضل.",
    },
    {
      id: "4",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-step-4-ar.webp",
      title: "تقديم المطالبات",
      subTitle: "feature",
      text: "سرعة وسهولة في تقديم المطالبات من خلال التطبيق ومتابعتها لتوفير عملية تقديم بسيطة.",
    },
  ],
  map: {
    title: "شبكة فروعنا",
    subTitle:
      "بنقربلك في كل  محافظة في مصر من خلال أكتر من 60 فرع في جميع أنحاء الجمهورية",
    placeholderGovernate: "المحافظة",
    placeholderBranch: "ابحث عن اقرب فرع لك  ",
    noOption: "لا توجد محافظات",
    noSearchResult: [
      "عذرًا لا يوجد فروع لبحثك حالياً",
      "جرّب تعديل اسم الفرع و تحقق من البيانات",
    ],
    openNow: "مفتوح الان",
    closeNow: "مغلق الان",
    workingHours: "مفتوح يوميًا 10:00 ص – 6:00 م (ما عدا الجمعة والسبت)",
    workingHours2: "مفتوح يوميًا 10:00 ص – 8:00 م (ما عدا الجمعة والسبت)",
    workingHours3: "مفتوح يوميًا 12:00 م – 8:00 م (ما عدا الجمعة والسبت)",
    workingHours4: "مفتوح يوميًا 10:00 ص – 10:00 م (ما عدا الجمعة والسبت)",
    workingHours5: "مفتوح يوميًا 10:00 ص – 10:00 م",
    KnowWay: "اعرف الطريق",
    Tab: ["الفروع", "الخريطة"],
    phone: "رقم الهاتف",
    openingHours: "ساعات العمل",
    branchAddress: "عنوان الفرع",
    list: [
      {
        name: "تقسيط سيارات بنزين و كهرباء سواء جديدة ومستعملة",
        url: "/products/auto",
      },
      {
        name: "تقسيط موتوسيكلات و اسكوتر بنزين و كهرباء سواء جديدة أو مستعملة",
        url: "/products/motorcycles",
      },
      { name: "تقسيط سيارات النقل", url: "/products/trucks" },
      { name: "تقسيط فرش البيت", url: "/products/home-furniture" },
      { name: "	قسيط تشطيب البيت", url: "/products/home-interior" },
      {
        name: "تمويل أخضر (تقسيط ألواح الطاقة الشمسية - الصوب الزراعية) ",
        url: "/products/green-finance",
      },
      { name: "تمويل عقاري", url: "/products/mortgage" },
      { name: "تقسيط الحج والعمرة", url: "/products/travel-and-tourism" },
      { name: "تقسيط اشتراكات الأندية", url: "/products/clubs" },
      {
        name: "تقسيط التعليم (مصاريف المدارس - الجامعات - الدراسات العليا - الدكتوراه - الدبلومات والكورسات)",
        url: "/products/education",
      },
      { name: "تقسيط المركبات المائية", url: "/products/watercraft" },
    ],
    secondDesc: "بجانب خدمات تمويلية وتأمينية تناسب جميع مراحل حياتك المختلفة",
    branch: {
      desc: "فرع شركة كونتكت في {{branch}}، خدمات تمويلية تشمل:",
    },
  },

  contact_homes: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-homes.svg",
      color: "#2D9A8F",
      title1: "كونتكت هومز",
      title2: "بداية جديدة لحياة متكاملة",
      description: `الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر رائدة التسويق العقاري، اصبح بإمكانك الاستفادة من عالم لا نهائي من المزايا و العروض التي توفر لك الحياة المتكاملة التي تحلم بها بخصومات كبيرة و أسعار خاصة. بداية جديدة لحياة متكاملة`,
    },
    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "الشروط الخاصة ببرنامج “كونتكت هومز",
      body: `أن يكون عميل حالي لدى كولدول بنكر`,
    },
    section_b: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title:
        "استمتع بعالم من المزايا الحصرية عند انضمامك إلى “Coldwell Banker Star Club”",
      body: [
        "نموذج تصميم ثلاثي الأبعاد مجاناً لغرفة المعيشة أو غرفة النوم أو أحد أقسام غرفة الاستقبال",
        "50% خصم على نموذج التصميم ثنائي الأبعاد وثلاثي الأبعاد عند التعاقد مقدمة من RD Design",
        "تمويل عقاري يصل الى 5 ملايين جنيه من كونتكت",
        "تمويل استهلاكي يصل الى 500 الف جنيه من كونتكت",
        "عروض حصرية وخصومات خاصة على دهانات جوتن، ايكيا و تكييفات كاريير",
      ],
    },
    section_c: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title:
        "مزايا وخصومات حصرية لعملاء”Coldwell Banker Star Club” مقدمة من كونتكت على",
      body: [
        "التمويل عقاري",
        "التسوق",
        "تمويل التشطيب",
        "تمويل السيارات",
        "الوساطة تأمينية",
      ],
    },
    section_d: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title:
        "استمتع بعالم من المزايا الحصرية عند انضمامك إلى “Coldwell Banker Star Club”",
      body: [
        "تأمين منزل مجانى لمدة عام",
        "وثيقة استبدال مفتاح",
        "تأمين على الهاتف المحمول، آيباد و التلفزيون",
        "خصم 50% على قيمة تأمين المنزل الثاني (الساحل الشمالي أو العين السخنة)",
      ],
    },
  },
  inistance: {
    Tittle: "احصل على موافقة فورية على الحد الائتماني",
    Tittle2:
      "رصيد يصل إلى 50,000 جنيه مصري يمكنك الحصول عليه على الفور! فقط اتبع هذه الخطوات",
    Start: "البدء",
  },
  Login: {
    Next: "التال\u064A",
    Login: "تسجيل دخول",
    PhoneTitle: "  أدخل رقم هاتفك    لتسجيل الدخول فى حسابك   ",
    PhoneLabel: "011xxxxxxxx ",
    PhoneError:
      " رقم الموبايل يجب أن يكون 11 رقم و يبدا بـ (010/011/012/015) مباشرة",
    ErrorMessPass:
      "رقم الهاتف أو كلمة المرور التي أدخلتها غير صحيحة. يرجى المحاولة مرة أخرى.",
    ErrorMessPhone: "لا يوجد حساب لهذا الرقم",

    ErrorLabel: "خطأ",
    PassTitle: "يرجى ادخال كلمة المرور",
    PassLabel: "كلمة المرور",
    ResetPassword: "هل نسيت كلمة المرور ؟",
    CheckUserExistence: "المستخدم غير موجود",
    OTPTitle:
      "تم ارسال كلمة المرور لمرة واحدة الى رقم هاتف ينتهى بالرقم  ، الرجاء ادخاله ادناه",
    UpdatePassword: "تعين كلمة السر ",
    ConfirmLabel: "تاكيد كلمة المرور",
    ErrorConFirmPass: "كلمات المرور غير متطابقة",
    SuccsessUpdatePAss:
      "تم تغيير كلمة المرور ، يرجى تسجيل الدخول للوصول إلى  حسابك",
    ResendOtp: "اعاده الارسال",
    OTPNotVerfy: "كلمة المرور لمرة واحدة غير صالحة",
    VerificationToken: "حدث خطأ برجاءالمحاولة مرة اخري",
    resetError: "الرجاء إدخال رقم هاتفك لإعادة تعيين كلمة المرور",
  },

  user_installements: {
    RemaniningAmounts: {
      title: "المتبقي لك",
      amount: "٢٠.٠٠٠",
      currency: "جنية مصري",
      totalAmountText: "المبلغ الكلي",
      paymentBtn: "تسديد القسط",
    },
    UpComingInstallement: {
      title: "الأقساط القادمة",
      paymentBtn: "تسديد الكل",
      UpComingDetails: [
        {
          id: "1",
          payTo: "تريدلاين إستور",
          payFor: "Macbook M1 Pro",
          totalAmountText: "المبلغ الكلي",
          totalAmount: "٦٤,٤٥٠",
          currency: "جنية مصري",
          whatPaid: "٢,٦٨٦",
          total_number_installments: "٢٤",
          number_paid_installments: "١٨",
          paymentBtn: "تسديد القسط",
        },
        {
          id: "2",
          payTo: "تريدلاين إستور",
          payFor: "Macbook M1 Pro",
          totalAmountText: "المبلغ الكلي",
          totalAmount: "٦٤,٤٥٠",
          currency: "جنية مصري",
          whatPaid: "٢,٦٨٦",
          total_number_installments: "٢٤",
          number_paid_installments: "١٨",
          paymentBtn: "تسديد القسط",
        },
        {
          id: "3",
          payTo: "تريدلاين إستور",
          payFor: "Macbook M1 Pro",
          totalAmountText: "المبلغ الكلي",
          totalAmount: "٦٤,٤٥٠",
          currency: "جنية مصري",
          whatPaid: "٢,٦٨٦",
          total_number_installments: "٢٤",
          number_paid_installments: "١٨",
          paymentBtn: "تسديد القسط",
        },
        {
          id: "4",
          payTo: "تريدلاين إستور",
          payFor: "Macbook M1 Pro",
          totalAmountText: "المبلغ الكلي",
          totalAmount: "٦٤,٤٥٠",
          currency: "جنية مصري",
          whatPaid: "٢,٦٨٦",
          total_number_installments: "٢٤",
          number_paid_installments: "١٨",
          paymentBtn: "تسديد القسط",
        },
      ],
    },
    PreviousDealing: {
      title: "التعاملات السابقة",
      nodataerr: "لا توجد بيانات حاليا يرجى المحاولة لاحقا ......",
      PreDealingHead: {
        product: "المنتج",
        seller: "البائع",
        date: "التاريخ",
        amount: "المبلغ",
        payMethod: "طريقة الدفع",
      },
    },
  },
  customer_services: {
    title: "للتحدث لخدمة عملاء كونتكت",
    whatsappCall: {
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/whatsapp-2.png",
      title: "التحدث من خلال الواتس اب",
      subTitle: "للتحدث من خلال خدمة رسائل الواتساب للإستجابة السريعة",
      arrow:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/next-arrow.png",
    },
    hotLineCall: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/call.png",
      title1: "التحدث من خلال ",
      title2: " الخط الساخن",
      subTitle: "١٦١٧٧",
    },
    ourLocation: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/location.png",
      title: "زور أحد فروعنا",
      arrow:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/next-arrow.png",
    },
  },
  profile: {
    title: "الملف الشخصي",
    img: "../images/userProfile",
    imgBtn: "تغير الصورة",
    email_title: "البريد الإلكتروني",
    extraInfo_title: "معلومات إضافية",
    editBtn: "تعديل",
  },
  userNav: {
    your_installement: "أقساطي",
    call_center: "تواصل معنا",
    profile: "الملف الشخصي",
    logout: "تسجيل خروج",
    welcome: "أهلا",
    loyaltyPoints: "نقاطك الحاليه",
  },

  referral_program: {
    title: "برنامج ترشيح العملاء",
    sub_title: "يمكنك ترشيح أصدقاءك والحصول على نقاط مجانية وخصومات حصرية",
    conditions: {
      title: "الشروط و الأحكام الخاصة بالبرنامج",
      conditions_list: [
        "لابد أن يكون من قام بالترشيح عميل مسجل لدى كونتكت",
        "لكي يستطيع عملاء كونتكت الحاليين الحصول على نقاط المكافآت لابد من أن يقوم العملاء الجدد بالقيام بعملية تعاقد على إحدى منتجات كونتكت",
        "لكونتكت تسوق وكونتكت تشطيب فقط لابد من العملاء المرشحين أن يقوموا بإتمام عملية شراء واحدة علي الاقل بعد الموافقة الائتمانية والتعاقد حتي يتمكن العملاء الحاليين الحصول على نقاط المكافآت تلقائياً",
        "يمكن لعملاء كونتكت الحاليين ترشيح معارفهم من خلال الموقع الإلكتروني، تطبيق كونتكت للموبايل، الاستمارات داخل الفروع، مراكز خدمة العملاء او من خلال منصات التواصل الاجتماعي الرسمية لكونتكت",
        "الحد الأقصى لعملاء كونتكت الحاليين ترشيح 10 عملاء جدد في الشهر الواحد",
      ],
    },
    program_benefits: "مميزات البرنامج",
    benefites_list: [
      "عملاء كونتكت الحاليين يتم مكافئتهم عن طريق الحصول علي نقاط المكافآت حيث يتم تحديد عدد النقاط طبقاً لمنتجات كونتكت المختلفة.",
      "يمكن استخدام نقاط المكافآت للشراء من شركاء برنامج المكافآت.",
      "يمكن استخدام النقاط في دفع الأقساط أو المصاريف الإدارية لكونتكت.",
    ],
  },

  application: {
    job_title: "مهندس برمجيات",
    job_desc:
      "نبحث عن مبرمج متميز للانضمام إلى فريقنا في تطوير وصيانة برامج الحاسوب. يجب أن يكون لديه خبرة سابقة في تطوير البرامج والتعامل مع لغات البرمجة المختلفة. سيعمل المبرمج في بيئة عمل مرنة ويجب أن يكون لديه القدرة على تحمل ضغط العمل والعمل بشكل فردي وفي فريق.",
    to_apply: "إن كنت ترغب في الانضمام إلينا يرجى ملء النموذج.",
    resume_upload: {
      title: "انقر أو اسحب الملف إلى هذه المنطقة للتحميل",
      sub_title:
        "دعم التحميل الفردي أو المجمع. يمنع منعا باتا تحميل بيانات الشركة أو ملفات الفرقة الأخرى",
    },
  },
  news: {
    title: "أخبارنا",
    subtitle: "اخبار تهمك عن كونتكت",
    minutes: " دقائق قراءة",
    read_more: "إقرأ المزيد",
    share: "شارك",
  },
  errorPage: {
    title: "لم يتم العثور ع الصفحة ",
    Home: "العودة الى الصفحة الرئيسية",
  },
  internetConnectionPage: {
    title: "عذراً!!",
    subTitle: "لا يوجد إتصال بالإنترنت. تحقق من إتصالك وحاول مرة اخرى",
    Home: "إعادة التحميل",
  },
  blogs: {
    title: "المدونات",
    latestBlog: " أحدث المدونات",
    intro: "مقدمة",
    table_content: "جدول المحتويات",
    other_blogs: "مدونات أخرى كتبها المؤلف",
    similar: "مدونات مماثلة",
    features: "احدث المواضيع",
    about_author: "عن المؤلف",

    authors: [
      {
        id: "رهف-محمد",
        name: "رهف محمد",
        bio: "أخصائية تسويق رقمي تتمتع بشغف في صناعة محتوى يثري ويجذب ويحقق نتائج حقيقية. تمتلك خلفية قوية في تحسين محركات البحث، واستراتيجيات المحتوى، وتجربة المستخدم، وتعمل على تبسيط المواضيع المعقدة من خلال مقالات مدوّنة تقدم قيمة حقيقية للقراء. تركّز في عملها على مساعدة الجمهور في اكتشاف رؤى عملية قابلة للتطبيق.",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/rahaf.jpg",
        sharedId: "1",
      },
    ],
  },

  Campaign: {
    Title1: `   شكرا لتواصلك مع كونتكت  !`,
    Title2: `برجاء ادخال بياناتك وسيقوم احد ممثلينا بالتواصل معك في اقرب وقت`,
    catalogueTitle: "كل إللي بتحلم بيه وأكتر بكتير بدوسة زرار",
    catalogueSubTitle: "ادخل بياناتك وهنتواصل معاك في الوقت إللي يناسبك",
    financing_title: "اشتري عربيتك BMW دلوقتي بأقل سعر فائدة في مصر",
    financing_pg: (
      <>
        <p>
          0% مصاريف ادارية | فائدة 4.4% فقط | ثلاث سنوات صيانة مجاناً| ضمان لمدة
          5 سنوات
        </p>
        <p>سجل طلب التمويل الآن</p>
      </>
    ),
  },

  //==============================feedBack======================================
  feedback: {
    sections: [
      {
        id: 1,
        type: "satisfactionRating",
        question: "ما مدى سهولة استخدام موقعنا؟",
        defaultOptions: [
          {
            id: 1,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/angryEmoj.svg",
            text: "صعب جدا",
          },
          {
            id: 2,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/sadEmoj.svg",
            text: "صعب",
          },
          {
            id: 3,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/mehEmoj.svg",
            text: "عادي",
          },
          {
            id: 4,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/happy.svg",
            text: "جيد",
          },
          {
            id: 5,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/goodEmoj.svg",
            text: "جيد جدا",
          },
        ],
      },

      {
        id: 2,
        type: "informationHelpful",
        question: "هل وصلت للمعلومة اللي محتاجها؟",
        options: [
          { id: 1, text: "نعم" },
          { id: 2, text: "لا" },
        ],
      },
    ],
    slider: {
      question: "هل تنصح بخدماتنا لعائلتك / أصدقائك؟",
      labels: {
        low: "لا أنصح",
        mid: "احتمال",
        high: "أنصح",
      },
    },
    buttonTitle: "رأيك يهمنا",
    textareaPlaceholder: "مقترحاتك لتحسين اداء الموقع ..",
    buttonText: "إرسال",
    successFeedback: "تم إرسال رأيك بنجاح",
    failFeedback: "حدث خطأ. يُرجى محاولة إرسال ملاحظاتك مرة أخرى.",
  },
  // ***********
  navbar_investment: "استثمار",
  investment_dropdown: [
    {
      url: "/investment/cash-management",
      color: colors.ratty,
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/cash-mangement.webp",
      title: "ادارة المحافظ",
    },
    {
      url: "/investment/income-trading",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/income-trading.png",
      title: "أدوات الدخل الثابت",
    },
    {
      url: "/investment/investment-fund",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/investment-fund.png",
      title: "صندوق استثمار كل يوم",
    },
  ],
  navbar_partnership: "انضم لشركاؤنا",
  partner_dropdown: [
    // {
    //   url: "/partnership/contact-now-merchant",
    //   color: colors.ratty,
    //   img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
    //   title: "شبكة تجار ContactNow",
    // },
    {
      url: "/partnership/leasing-partners",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "انضم كشريك للتأجير التمويلي",
    },
    {
      url: "/partnership/factoring-partners",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "انضم كشريك للتخصيم",
    },
    {
      url: "/partnership/business-partners",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "هيئات أخرى",
    },
  ],

  business: {
    logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-ar-white.png",
    cover_title: "شريكك التمويلي",
    cover_body:
      "كبّر أعمالك مع خدمات التأجير التمويلي والتخصيم وشراء المحافظ العقارية، وحلول التأمين والاستثمار اللي تناسب احتياجاتك وتساعدك تاخد خطوتك الجاية.",
    btn1: "Request service",
    btn2: "انضم إلينا",
    sponsor_title: "شركاؤنا",
    sponsors: [
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/1.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/2.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/3.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/4.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/5.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/6.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/7.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/8.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/9.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/10.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/11.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/12-ar.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/13-ar.png", // fawry
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/15.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/16-ar.png", // basata
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/17-ar.png", // jumia
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/raya.svg", //raya
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/orange.svg", //Orange
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/vodafone.svg", //Vodafone
    ],
    plans_title: "Quis autem vel eum iure reprehenderit qui",
    plans_subtitle: "Tagline",
    plans_description:
      "diam laoreet consectetur libero, elit sollicitudin. felis, ac ipsum In nisi id ullamcorper felis, efficitur. faucibus elit. orci in Ut urna. massa Cras orci",
    btn11: "More",
    btn22: "Follow",
    card_title: "Quis autem vel eum iure reprehenderit qui",
    card_description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros.",
    testimonial_title: "قصص نجاح من شركائنا",
    testimonial_description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    reviews_business: [
      {
        avatar:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/hossam-avatar.jpg",
        name: "السيد / حسام عز",
        role: "رئيس القطاع التجاري، شركة فوري",
        rating:
          'سعداء للغاية بشراكتنا مع "كونتكت" الممتدة على مدار السنوات الماضية والتي تكللت بالعديد من النجاحات إذ أصبحت قنوات فوري المختلفة تمثل احد اهم قنوات التحصيل التي يسرت علي عملاء كونتكت سداد مستحقاتهم بسهوله ويسر، وتمثل هذه الخطوة توطيدا للتعاون بين الجانبين بهدف تعزيز قيم الشمول المالي ودفع عجلة التحول الرقمي.',
      },
      {
        avatar:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/adham-avatar.jpg",
        name: "السيد / ادهم حسني",
        role: "رئيس قطاع التخطيط والمنتجات، شركة كارزامي",
        rating:
          'لقد لعبت شراكتنا مع "كونتكت" دورًا مهمًا في نجاحنا من خلال تقديم الموافقات السريعة والتعاون المبتكر. ويشرفنا أن يكونوا شركاء لنا، ونحن فخورون للغاية بارتباطنا بهم',
      },
      {
        avatar:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mahmoud.jpg",
        name: "السيد / محمود السيد",
        role: "المؤسس المشارك والرئيس التنفيذي، متصفح وصلة",
        rating:
          'نحن نؤمن بأن شراكتنا مع شركة "كونتكت" تتيح لنا توسيع عروضنا بشكل مستمر وإدخال طرق جديدة لمساعدة المستهلكين على توفير المال، والدفع بشكل آمن، والاقتراض بمرونة',
      },
    ],
    news_title: "أخبارنا",
    news_description: "Main news",
    btn111: "عرض الكل",
    accordion: [
      {
        title: "كيف تدعم كونتكت الشركات وتساعدها على تجاوز العقبات المالية؟ ",
        description:
          "نحن ندعم مختلف الشركات من خلال دعم الأصول الأساسية والتدفق النقدي الفوري ، حيث توفر كونتكت مجموعة واسعة من الحلول التمويلية من خلال برامج التأجير التمويلي والتخصيم  وحلول  Laas والمزيد!",
      },
      {
        title:
          "كيف تساعد كونتكت الأفراد والشركات على حماية المستقبل الصحى والمالي ؟",
        description:
          "تساهم كونتكت في تمكين الأفراد والشركات على حد سواء في حماية صحتهم ومستقبلهم المالي من خلال تقديم حلول متنوعة تشمل: الخطط التأمينية الصحية الفردية والجماعية، وخطط تأمين على الحياة، وخطط استثمارية، وخطط تقاعد، الحماية والادخار، والمزيد!",
      },
      {
        title: "كيفية تقديم طلب تمويل من كونتكت؟",
        description:
          "يمكنك ان تقدم طلب التمويل الخاص بك من خلال وسائل التواصل المختلفة مثل فروع كونتكت المنتشرة في كل المحافظات، الموقع الالكتروني، تطبيق الهاتف المحمول، الواتساب أو الاتصال التليفوني بمركز خدمة العملاء 16177.",
      },
      {
        title: "لماذا تختار شركات التمويل بدلا من التمويل البنكي؟",
        description:
          "تمنح شركات التمويل اجراءات أسهل وأسرع من الإقراض المصرفي التقليدي بالإضافة الي موافقة أسهل من البنوك.",
      },
    ],
    faqs: "الأسئلة الشائعة",
    faqs_description: "نُمكنك من تحقيق اهدافك المالية",
  },
  exclusiveOffersList: [
    {
      optionId: "2",
      title: "عربية دونج فونج",
      value: "DongfengCar",
    },
    {
      optionId: "3",
      title: "عربية فويا",
      value: "VoyahCar",
    },
    {
      optionId: "4",
      title: "عربية سمارت",
      value: "SmartCar",
    },
    {
      optionId: "5",
      title: "عرض فولفو",
      value: "VolvoCar",
    },
    {
      optionId: "6",
      title: "عرض الجولف كار",
      value: "GolfCarOffer",
    },
    {
      optionId: "7",
      title: "عرض الجت اسكي",
      value: "JetSkiOffer",
    },
    {
      optionId: "8",
      title: "عرض جت كار",
      value: "JetCarOffer",
    },
    {
      optionId: "9",
      title: "عرض سبيد بوت",
      value: "SpeedBoatOffer",
    },
    {
      optionId: "10",
      title: "عرض فرش البيت",
      value: "HomeFurniture",
    },
  ],
  business_profile_list: [
    {
      optionId: "1",
      title: "تمويل السيارات",
      value: "Auto",
    },
    {
      optionId: "1",
      title: "تمويل الدراجات النارية",
      value: "Motorcycles",
    },
    {
      optionId: "1",
      title: "تمويل النقل",
      value: "Trucks",
    },
    {
      optionId: "1",
      title: "تمويل المركبات المائية",
      value: "Watercrafts",
    },
    {
      optionId: "2",
      title: "تمويل عقاري",
      value: "Mortgage",
    },
    {
      optionId: "2",
      title: "تمويل التشطيب",
      value: "Homes",
    },
    {
      optionId: "2",
      title: "تمويل فرش البيت",
      value: "HomeFurniture",
    },
    {
      optionId: "5",
      title: "تمويل التعليم",
      value: "Education",
    },
    {
      optionId: "5",
      title: "اشتراكات الاندية",
      value: "Clubs",
    },
    {
      optionId: "5",
      title: "تمويل تسوق",
      value: "shopping",
    },
    {
      optionId: "2",
      title: "تمويل الصيانة",
      value: "Maintenance",
    },

    {
      optionId: "3",
      title: "وساطة تامينية",
      value: "Brokerage",
    },
    {
      optionId: "3",
      title: "ثروة لتأمينات الحياة",
      value: "Life",
    },
    {
      optionId: "3",
      title: "ثروة للتأمين",
      value: "Insurance",
    },

    {
      optionId: "4",
      title: "حضانة",
      value: "Education",
    },
    {
      optionId: "4",
      title: "مدارس",
      value: "Education",
    },
    {
      optionId: "4",
      title: "جامعات",
      value: "Education",
    },
    {
      optionId: "4",
      title: "دراسات عليا وكورسات",
      value: "Education",
    },
    {
      optionId: "6",
      title: "التمويل الأخضر",
      value: "GreenFinance",
    },
    {
      optionId: "7",
      title: "مناسك",
      value: "Manasik",
    },

    // *********
    {
      title: "تمويل التخصيم",
      value: "Factoring",
    },
    {
      title: "تأجير تمويلي",
      value: "Leasing",
    },
    // *******
  ],
  //* sustainability
  sus_t1: "الاستدامة",
  sus_b1: `تعد الاستدامة عنصراً هاماً في مواجهة التحديات البيئية والاجتماعية تعمل كونتكت على تعبئة الموارد المالية وتخصيصها لمبادرات التنمية المستدامة وحماية البيئة وتنمية الموارد الطبيعية بالإضافة إلى العدالة الاجتماعية والاقتصادية. 
توفر كونتكت التمويل ورأس المال اللازم لمختلف المشاريع والمبادرات البيئية والحماية المجتمعية مثل مبادرات حماية محدودي الدخل وتمكين المرأة وذوى الهمم. وتأتي الحاجة إلى تمويل الاستدامة من خلال المسئولية المجتمعية للشركة حيث أن النظم المالية التقليدية غالبا ما تعطي الأولوية للمكاسب القصيرة الأجل على حساب مشاريع الاستدامة الطويلة الأجل. ونتيجة لذلك، كان هناك تركيز متزايد لدى كونتكت على دمج اعتبارات الاستدامة في عمليات صنع القرار المالي وتيسير التمويل الأخضر لدعم مشروعات الطاقة النظيفة، حماية البيئة، الحفاظ على الموارد والحرص الدائم على اتباع ومواكبة السياسات الحكومية التي تحفز الاستثمارات في هذا المجال.
`,
  sus_t2: "اهداف التنمية المستدامة",
  sus_st2:
    "تتوافق خطة عملنا للفترة 2023-2025 مع أهداف التنمية المستدامة التالية:",
  sus_b2: [
    "الصحة الجيدة الرفاهية",
    "التعليم الجيد",
    "العمل اللائق والنمو الاقتصادي",
    "الحد من أوجه عدم المساواة",
    "العمل المناخي",
    "عقد الشراكات من أجل تحقيق الأهداف",
  ],
  sus_img2:
    "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sus-logo.webp",
  sus_reports: [
    {
      title: "اطّلع على تقرير الاستدامة الخاص بنا لعام 2026",
      link: "https://contact-app-prod.s3.us-east-2.amazonaws.com/IR_investors/TCFD-CFH-2026.pdf",
    },
    {
      title: "اطّلع على تقرير الاستدامة الخاص بنا لعام 2024",
      link: "/contact-sustainability-report2023.pdf",
    },
  ],

  // ************
  Readmore: "اقرأ المزيد",
  pages_main_tags: {
    home: {
      title: "كونتكت | أول شركة تمويل استهلاكي في مصر | افضل شركة تقسيط",
      meta_desc:
        "احصل على حلول التمويل مع افضل شركة تقسيط وتمويل في مصر، بما يشمل تمويل السيارات، التعليم، السياحة، تصميم وتشطيب المنزل، تمويل عقاري وتمويل الصيانة مع كونتكت.",
      h1: "مرحباً بكم في كونتكت",
      h2: "حلول تمويلية مبتكرة لجميع احتياجاتك المالية",
    },
    about: {
      title: "من نحن | تعرف على كونتكت ورحلتنا في تقديم الحلول المالية",
      meta_desc:
        "اعرف أكتر عن كونتكت المالية، الشركة الرائدة في مصر لتقديم حلول تمويل السيارات، التأمين، التمويل الاستهلاكي وتمويل الشركات، وكمان هتلاقي فروع كونتكت قريبة منك",
      h1: "نبذة عن كونتكت",
    },
    products: {
      insurance: {
        title: "الوساطة التأمينية من كونتكت - خدمات التأمين للأفراد والشركات",
        meta_desc:
          "استمتع بأفضل خطط التأمين في مصرمع حماية شاملة لك ولعائلتك بأسعار وخيارات مختلفة تناسبك مع كونتكت، بما يشمل تأمين الحياة، التأمين الصحي وتأمين الممتلكات.",
        h1: "أفضل خطط التأمين في مصر",
        h2: "حلول التأمين",
      },
    },
    epyament: {
      title: "كونتكت باي | الدفع الالكتروني ودفع الفواتير مع كونتكت باي ",
      meta_desc:
        "مع كونتكت باي ادفع كل فواتيرك من مكان واحد. تقدر تدفع فواتير الكهرباء والغاز والمياه، أقساط التأمين، مصاريف المدارس والجامعات وغيرها من المدفوعات بسرعة وأمان.",
      h1: "كونتكت بــاي",
      h2: "حلول دفع مبتكرة وسريعة",
    },
    investment: {
      title: "إدارة المحافظ وأسواق رأس مال الدين في مصر من كونتكت",
      meta_desc:
        "كونتكت الشريك الموثوق في سوق رأس مال الدين بمصر، نقدم خدمات التوريق وإصدار الصكوك وإدارة الاكتتاب لمساعدة الشركات على تحقيق أهدافها المالية بكفاءة وأمان.",
      h1: "فرص استثمارية واعدة مع كونتكت",
      h2: "استثماراتنا",
    },
    sarwaInsurance: {
      title: "ثروة للتأمين: اهم شركة تأمين ضمن مجموعة كونتكت المالية",
      meta_desc:
        "حماية ما يهمك تبدأ مع ثروة للتأمين، من خلال خطط تأمين شاملة مصممة للأفراد والشركات في مصر. نقدم لك حلولًا موثوقة وخبرة طويلة كجزء من مجموعة كونتكت المالية.",
      h1: "ثروة للتأمين",
      h2: "تغطية شاملة لراحة بالك",
    },
    blogs: {
      title: "دليل التمويل والتقسيط الشامل - نصائح التمويل مع كونتكت",
      meta_desc:
        "خليك دايمًا على اطلاع بآخر النصائح والمستجدات المالية من كونتكت، واعرف إزاي تاخد قرارات أذكى وتستفيد من حلول تمويل مرنة تناسب احتياجاتك مع مقالات عن التمويل.",
      h1: "",
      h2: "أحدث المقالات",
    },
    contactUs: {
      title: "تواصل معنا | اتصل بخدمة عملاء كونتكت واسأل عن تفاصيل التمويل",
      meta_desc:
        "تواصل مع افضل شركة تقسيط الآن واتصل بخدمة عملاء كونتكت على 16177 واسأل عن كل تفاصيل التمويل والخدمات المتاحة، فريقنا جاهز يرد على كل استفساراتك بسرعة وسهولة.",
      h1: "تواصل معنا",
      h2: "مستعدون دائمًا لمساعدتك",
    },
    login: {
      title: "تسجيل الدخول - حساب كونتكت الخاص بك",
      meta_desc:
        ".قم بتسجيل الدخول إلى حساب كونتكت الخاص بك للوصول إلى جميع خدماتنا وإدارة حساباتك بسهولة وأمان",
      h1: "تسجيل الدخول إلى حسابك",
      h2: "تسجيل الدخول إلى حسابك",
    },
    sustainability: {
      title: "الاستدامة في كونتكت | استراتيجية الاستدامة لمستقبل أفضل",
      meta_desc:
        "اكتشف إزاي كونتكت بتدعم الاستدامة من خلال مبادرات ومسؤوليات مجتمعية تهدف لبناء مستقبل أفضل وأكثر استدامة، مع تأثير إيجابي على الأفراد والبيئة والمجتمع.",
      h1: "الاستدامة في كونتكت",
      h2: "التزامنا بمستقبل أخضر ومستدام",
    },
    sarwaLife: {
      title: "ثروة لتأمينات الحياة ضمن مجموعة كونتكت المالية القابضة",
      meta_desc:
        "خطط تأمين الحياة من ثروة تمنحك الحماية والاطمئنان لمستقبل عائلتك. احصل على تغطية تأمينية شاملة وخدمات احترافية من ثروة لتأمينات الحياة، التابعة لمجموعة كونتكت.",
      h1: "أمان لعائلتك",
      h2: "ثروة لتأمينات الحياة",
    },
    sarwaCapital: {
      title: "ثروة كابيتال - الرائدة في سوق رأس مال الدين بمصر منذ 2005",
      meta_desc:
        "ثروة كابيتال التابعة لمجموعة كونتكت، الشريك الرائد في سوق رأس مال الدين بمصر، رتبت وأصدرت أكثر من 26 مليار جنيه منذ 2005، وأول مصدر مرخص للصكوك في السوق المصري.",
      h2: "خدماتنا الاستثمارية",
    },
    referralProgram: {
      title: "برنامج ترشيح العملاء من كونتكت | رشح اصحابك واكسب مكافآت",
      meta_desc:
        "استفيد من برنامج ترشيح العملاء من كونتكت وابدأ تكسب مكافآت بسهولة، رشح أصحابك ومعارفك، وكل ترشيح ناجح يزود فرصك في الحصول على مزايا وعروض حصرية وتجربة مميزة.",
      h1: "مكافآت مع كل ترشيح",
      h2: "قول لأصحابك وعائلتك عن كونتكت",
    },
    rewards: {
      title: "برنامج المكافآت - كونتكت",
      meta_desc:
        "استفد من برنامج المكافآت في كونتكت وتمتع بأفضل الخصومات والمزايا الحصرية لعملائنا المميزين في مصر.",
      h1: "استمتع بالمزايا الحصرية",
      h2: "برنامج المكافآت من كونتكت",
    },
    ourBranches: {
      title: "فروع كونتكت - اماكن وفروع افضل شركة تمويل في مصر",
      meta_desc:
        "اعثر على أقرب فرع من فروع كونتكت في جميع أنحاء مصر. تعرف على جميع اماكن فروعنا واحصل على خدمات التمويل والتقسيط التي تحتاجها بأسرع الإجراءات وأفضل تجربة.",
      h1: "في كل مكان فرع كونتكت قريب منك",
      h2: "فروعنا",
    },
    ourBrands: {
      title: "علاماتنا التجارية | تعرف على العلامات التجارية لكونتكت",
      meta_desc:
        "اعرف كل حاجة تخص العلامات التجارية لكونتكت، وتشمل كونتكت، ثروة حياة، ثروة تأمين، ثروة كابيتال وكونتكت كار، لتقديم حلول مالية وتأمينية متكاملة في مصر.",
      h1: "علاماتنا التجارية",
      h2: "علاماتنا التجارية",
    },
    branchDetails: {
      default: {
        title: "كونتكت {{branch}}: مكتب تمويل بالقرب منك",
        meta_desc:
          "هل تبحث عن فرع كونتكت في {{branch}}؟ احصل على الاتجاهات، مواعيد العمل، وبيانات الاتصال لفرعنا في {{branch}}. اتصل بنا على 16177.",
      },

      "abu-kibir": {
        title: "فرع كونتكت أبو كبير - العنوان ورقم الهاتف لفرع أبو كبير",
        meta_desc:
          "فرع كونتكت أبو كبير في الشرقية بيوفرلك كل خدمات التمويل والتقسيط بسهولة وسرعة. اعرف عنوان فرع أبو كبير بالتفصيل، رقم التليفون ومواعيد العمل قبل ما تزورنا.",
      },

      "menofia-shibin-elkom": {
        title: "كونتكت شبين الكوم | مواعيد وعنوان فرع شبين الكوم المنوفية",
        meta_desc:
          "لو بتدور على فرع كونتكت في شبين الكوم، هنا هتلاقي العنوان ورقم التواصل ومواعيد العمل، وكمان كل خدمات التمويل والتقسيط المتاحة جوه فرع شبين الكوم في المنوفية.",
      },

      "alexandria-ring-road": {
        title: "كونتكت الإسكندرية الدائري | عنوان ورقم فرع الدائري",
        meta_desc:
          "فرع كونتكت الإسكندرية الدائري بيوفرلك خدمات التمويل والتقسيط بسرعة وسهولة. اعرف عنوان الفرع بالتفصيل، رقم التليفون ومواعيد العمل قبل ما تزورنا في فرع الدائري ",
      },

      "alexandria-el-agamy": {
        title: "كونتكت العجمي بالإسكندرية | عنوان ومواعيد فرع العجمي",
        meta_desc:
          "فرع كونتكت الإسكندرية العجمي بيوفر حلول تمويل وتقسيط مناسبة لاحتياجاتك. اعرف عنوان فرع العجمي ومواعيد العمل أو اتصل بينا على 16177 لمزيد من التفاصيل.",
      },

      "alexandria-corniche": {
        title: "كونتكت الإسكندرية الكورنيش | حلول تمويل متكاملة في فروعنا",
        meta_desc:
          "فرع كونتكت الإسكندرية الكورنيش بيوفر برامج تمويل وتأمين وادخار ذكية بخبرة أكتر من 20 سنة. استثمر لمستقبلك واستفيد من حلول دفع مرنة تناسبك من خلال فرع الكورنيش",
      },
      "6th-october": {
        title: "فرع كونتكت 6 أكتوبر | تقسيط وتمويل وخدمات مالية متكاملة",
        meta_desc:
          "فرع كونتكت 6 أكتوبر بيقدملك حلول تقسيط مرنة تبدأ من 10% وتمويل لحد 10 مليون جنيه. خدمات تأمين واستثمار وادخار بخبرة أكتر من 20 سنة. كلمنا دلوقتي على 16177.",
      },
      "alexandria-roshdy": {
        title: "كونتكت رشدي الإسكندرية | قسط بسهولة في فرع رشدي اسكندرية",
        meta_desc:
          "في فرع رشدي بالإسكندرية، كونتكت بتوفرلك تقسيط مرن وخيارات تمويل تناسبك، مع خدمات تأمين واستثمار تساعدك تخطط لمستقبلك بثقة. زور الفرع او تواصل على 16177.",
      },
      aswan: {
        title: "فرع كونتكت أسوان | اسأل عن التمويل والتقسيط في فرع اسوان",
        meta_desc:
          "فرع كونتكت أسوان بيوفرلك حلول مالية متكاملة من تقسيط مرن وتمويل قوي، مع برامج تأمين وادخار تساعدك تحقق أهدافك، زور فرع اسوان للتمويل او اتصل بينا 16177.",
      },
      asyut: {
        title: "كونتكت أسيوط | افضل حلول تمويل وتقسيط تناسبك في اسيوط",
        meta_desc:
          "في كونتكت أسيوط هتلاقي أنظمة تقسيط مرنة وخطط تمويل لحد 10 مليون جنيه، مع خدمات تأمين واستثمار تدعم مستقبلك المالي. تقدر تزور فرع اسيوط دلوقتي او كلمنا 16177.",
      },
      benha: {
        title: "كونتكت بنها | تقسيط مرن وخدمات مالية متكاملة في فرع بنها",
        meta_desc:
          "فرع كونتكت بنها بيوفرلك حلول تقسيط سهلة وتمويل مناسب لاحتياجاتك، مع خدمات تأمين وادخار واستثمار بخبرة كبيرة. تقدر تزور فرع بنها لو عندك اي استفسار عن التمويل.",
      },
      "beni-mazar": {
        title: "حلول تمويل وتقسيط مرنة في فرع بني مزار من كونتكت",
        meta_desc:
          "زور فرع كونتكت بني مزار واكتشف خيارات تمويل وتقسيط تناسب احتياجاتك بسهولة، بخطط مرنة وشروط ميسرة تساعدك على اختيار الأنسب لك. فرع بني مزار بيقدملك حلول التمويل",
      },
      "beni-suef": {
        title: "كونتكت بني سويف | برامج تمويل وتقسيط تناسب احتياجاتك",
        meta_desc:
          "استفد من مجموعة متنوعة من الحلول التمويلية في فرع كونتكت بني سويف، مع أنظمة مرنة وخيارات متعددة مصممة لتناسب ميزانيتك. تقدر تتواصل مع فرع بني سويف دلوفتي.",
      },
      "city-stars-mall": {
        title: "كونتكت سيتي ستارز | خيارات تمويل وتقسيط سهلة وسريعة",
        meta_desc:
          "اكتشف في فرع كونتكت سيتي ستارز مجموعة من الحلول التمويلية وخطط التقسيط المرنة التي تمنحك تجربة أسرع وأسهل لاختيار ما يناسبك. اتصل على 16177 لمزيد من المعلومات",
      },
      damanhour: {
        title: "كونتكت فرع دمنهور | حلول تمويل مرنة بخيارات متعددة",
        meta_desc:
          " فرع كونتكت دمنهور يوفر لك برامج تمويل متنوعة وأنظمة تقسيط مرنة تساعدك على الوصول للحل المناسب بطريقة سهلة. اتصل بفرع دمنهور دلوقتي او على الخط الساخن 16177",
      },
      damietta: {
        title: "فرع دمياط من كونتكت | تمويل وتقسيط ببرامج مرنة تناسبك",
        meta_desc:
          "تعرف على خدمات التمويل والتقسيط في فرع كونتكت دمياط واستفد من حلول متعددة مصممة لتمنحك مرونة أكبر في الاختيار. زور فرع دمياط دلوقتي لمعرفة جميع خدمات التمويل",
      },
      dokki: {
        title: "فرع كونتكت الدقي | حلول تمويل سهلة ومرنة من فرع الدقي",
        meta_desc:
          "فرع كونتكت الدقي بيوفرلك حلول مالية مرنة، من برامج التمويل والتقسيط لخطط السداد المريحة، مع خبرة طويلة في السوق وفريق جاهز يرشحلك الاختيار الأنسب لاحتياجاتك.",
      },
      "downtown-5th-settlement": {
        title: "فرع داون تاون التجمع الخامس | تقسيط وتمويل لحد 10 مليون",
        meta_desc:
          "لو بتدور على تمويل وخطط تقسيط مريحة، فرع كونتكت داون تاون التجمع الخامس بيقدملك اختيارات متنوعة بمقدم يبدأ من 10٪ فقط، مع حلول تأمين تساعدك تخطط لمستقبلك بثقة.",
      },
      "el-gouna": {
        title: "كونتكت فرع الجونة | خدمات تمويل وتأمين وادخار متكاملة",
        meta_desc:
          "في فرع كونتكت الجونة تقدر تستفيد من خدمات مالية متكاملة تشمل التمويل والتقسيط، علشان تختار الحل اللي يناسب أسلوب حياتك ويخدم خططك المالية تواصل مع فرع الجونة",
      },
      "el-abaseya": {
        title: "كونتكت فرع العباسية | خدمات مالية شاملة وتمويل مرن",
        meta_desc:
          "فرع كونتكت العباسية بيقدملك مجموعة متكاملة من خدمات التمويل والتقسيط، مع أنظمة سداد مرنة بحرية أكبر في الاختيار، وفريق متخصص جاهز يساعدك توصل للحل الأنسب ليك.",
      },
      "el-bahr-el-azam": {
        title: "فرع البحر الأعظم | تمويل وتقسيط مرن من فرع البحر الاعظم",
        meta_desc:
          "زور دلوقتي فرع كونتكت البحر الأعظم واستفيد من حلول التمويل والتقسيط المرنة بمقدم يبدأ من 10% وتمويل يصل إلى 10 مليون جنيه. اتصل الآن بالخط الساخن 16177.",
      },
      "el-mahalla-el-kubra": {
        title: "فرع المحلة الكبرى للتمويل | حلول تمويل وتقسيط مرنة مع كونتكت",
        meta_desc:
          "زور فرع كونتكت المحلة الكبرى واعرف أفضل حلول التمويل والتقسيط اللي تناسب احتياجاتك، بمقدم يبدأ من 10٪ وتمويل يصل لـ10 مليون جنيه، مع فريق جاهز يساعدك.",
      },
      faisal: {
        title: "فرع كونتكت فيصل | تمويل وتقسيط يناسبك مع فرع فيصل للتمويل",
        meta_desc:
          "في فرع كونتكت فيصل هتلاقي حلول تمويل وتقسيط مرنة تناسب ميزانيتك، بمقدم يبدأ من 10٪ وتمويل يصل لـ10 مليون جنيه، مع خدمات تأمين وادخار واستثمار في مكان واحد.",
      },
      faiyum: {
        title: "فرع كونتكت الفيوم | حلول تمويل مرنة في فرع الفيوم للتقسيط",
        meta_desc:
          "زور فرع كونتكت الفيوم واستفيد من برامج التمويل والتقسيط اللي تناسب احتياجاتك، فرع الفيوم للتمويل بيقدملك جميع الخدمات المالية عشان تساعدك تحقق أهدافك.",
      },
      giza: {
        title: "فرع كونتكت الجيزة | حلول تمويل وحلول مالية تناسب احتياجاتك",
        meta_desc:
          "فرع كونتكت الجيزة بيوفرلك حلول تمويل وتقسيط مرنة، بمقدم يبدأ من 10٪ تقدر تمول من خلال فرع الجيزة الخاص بنا، مع خدمات تأمين وادخار واستثمار تناسب أسلوب حياتك.",
      },
      "masr-al-gadida": {
        title: "فرع مصر الجديدة | تمويل وتقسيط بكل سهولة من كونتكت",
        meta_desc:
          "زور فرع كونتكت مصر الجديدة واختار من بين مجموعة متنوعة من حلول التمويل والتقسيط، بتمويل يصل لـ10 مليون جنية من فرع مصر الجديدة، مع فريق متخصص يساعدك في كل خطوة.",
      },
      helwan: {
        title: "فرع كونتكت حلوان - تمويل وتقسيط وتأمين وادخار بمقدم 10%",
        meta_desc:
          "فرع كونتكت حلوان بيقدملك تمويل وتقسيط بمقدم 10% ولحد 10 مليون جنيه على مدار 5 سنين، مع تأمين وادخار واستثمار ودفع مرن. قدم بسهولة وموافقة سريعة، اتصل بنا 16177",
      },
      hurghada: {
        title: "فرع الغردقة - أمن مستقبلك ومستقبل أسرتك مع كونتكت الغردقة",
        meta_desc:
          "فرع كونتكت الغردقة بيوفرلك برامج تأمين شاملة تحميك وتحمي اللي بتحبهم، جنب باقة تمويل وتقسيط مرنة بمقدم من 10% فقط وموافقة سريعة. قدم بسهولة، اتصل بنا 16177",
      },
      ismailia: {
        title: "فرع كونتكت الإسماعيلية - ابدأ رحلة الادخار الذكي من هنا",
        meta_desc:
          "فرع كونتكت الإسماعيلية بيساعدك تبدأ خطط ادخار ذكية توصلك لأهدافك المالية، مع خيارات تمويل وتقسيط مرنة بمقدم من 10% وموافقة سريعة. قدم بسهولة، اتصل بنا 16177",
      },
      "kafr-el-sheikh": {
        title: "فرع كفر الشيخ - استثمر فلوسك بأمان وثقة مع كونتكت",
        meta_desc:
          " فرع كونتكت كفر الشيخ بيفتحلك فرص استثمار تعزز مستقبلك المالي، جنب باقة تمويل وتقسيط مرنة بمقدم يبدأ من 10% فقط ولحد 5 سنين سداد. قدم بسهولة، اتصل بنا 16177",
      },
      "kafr-el-dawar": {
        title: "فرع كفر الدوار من كونتكت - وسائل دفع مرنة تلائم ميزانيتك",
        meta_desc:
          "فرع كونتكت كفر الدوار بيوفرلك وسائل دفع مرنة تناسب نمط حياتك وميزانيتك، مع تمويل وتقسيط بمقدم من 10% لحد 10 مليون جنيه. قدم بسهولة وموافقة سريعة، اتصل بنا 16177",
      },
    },
    productsPage: {
      title: "جميع خدمات كونتكت - أفضل حلول التمويل والتقسيط",
      meta_desc:
        "اكتشف مجموعة خدمات كونتكت الكاملة. من حلول التمويل للأفراد والشركات لأفضل خطط التأمين في مصر.",
      h1: "استمتع بأفضل خدمات التمويل والتقسيط في مصر",
      h2: "جميع منتجات وخدمات كونتكت",
    },
    companies: {
      title: "تمويل الشركات مع كونتكت | افضل خدمات تمويلية للشركات في مصر",
      meta_desc:
        "اكتشف افضل حلول التمويل للشركات من كونتكت في مصر، الخدمات التمويلية للشركات تشمل: التمويل، التأجير التمويلي والتخصيم المصممة خصيصًا لدعم نمو شركتك وأعمالك.",
      h1: "تمويل الشركات في مصر",
      h2: "تمويل الشركات من كونتكت",
    },
    partnership: {
      contactNowMerchant: {
        title: "ContactNow للتجار | حلول تمويل للتجار مع كونتكت ناو",
        meta_desc:
          "انضم لشبكة شركاء كونتكت ناو ووسع نمو أعمالك من خلال تقديم خيارات تمويل مرنة وسريعة لعملائك، كونتكت ناو هي افضل وسيلة لتعزيز المبيعات وبناء ثقة أكبر.",
        h1: "كن شريك كونتكت",
        h2: "برنامج كونتكت للمتاجر",
      },
      OtherEntities: {
        title: "توريد منتجات وخدمات بنظام التقسيط | انضم لشركاء كونتكت",
        meta_desc:
          "كونتكت بتتعاون مع جهات وشركاء متنوعين وفي مختلف الجهات عشان تقدم لك خدمات مالية متطورة وحلول تمويل مرنة تساعد العملاء يوصلوا لأفضل الفرص بسهولة وثقة.",
        h2: "شركاء النجاح",
      },
      Vehicles: {
        title: "توريد السيارات ومعدات النقل | انضم لشبكة موردين كونتكت",
        meta_desc:
          "مع شراكات كونتكت الواسعة في قطاع السيارات والنقل ومع موردي السيارات، تقدر تلاقي حلول تمويل متكاملة تسهّل عليك شراء المركبة المناسبة لاحتياجاتك بأريحية.",
        h2: "شركاؤنا في قطاع السيارات",
      },
      Medical: {
        title: "تقسيط المعدات الطبية للأطباء والمؤسسات - شبكة موردين كونتكت",
        meta_desc:
          "كونتكت بتتعاون مع أفضل موردي المستلزمات الطبية لتوفير حلول تمويل مرنة تساعد الأفراد والشركات على الوصول لاحتياجاتهم من المستلزمات الطبية بسهولة وراحة.",
        h2: "شركاؤنا في قطاع المستلزمات الطبية",
      },
    },
    media: {
      title: "المركز الاعلامي واهم الاحداث | آخر اخبار وفعاليات كونتكت",
      meta_desc:
        "تابع آخر الأخبار والبيانات الصحفية والتغطية الإعلامية والفعاليات لشركة كونتكت من المركز الاعلامي الخاص بنا، كونتكت هي الشركة الرائدة في حلول التمويل في مصر.",
    },
    careers: {
      title: "فرص عمل في كونتكت المالية | وظائف شركات التمويل في مصر",
      meta_desc:
        "استكشف فرص العمل في كونتكت وانضم لفريق بيضم أكتر من 2500 موظف، واستفيد من بيئة عمل بتشجع على التطور المهني والنمو وبناء مسار وظيفي قوي في قطاع التمويل.",
      h1: "الوظائف",
      h2: "إذا كنت ترغب في الانضمام إلينا.",
    },

    contactUae: {
      title: "خدمات التمويل في الإمارات | تواصل مع كونتكت لخدمات التمويل",
      meta_desc:
        "تواصل مع كونتكت في الإمارات واستفيد من حلول تمويل مرنة تناسب احتياجاتك الشخصية أو التجارية، مع خدمات مصممة علشان تساعدك تحقق أهدافك. تواصل على 971547004400+",
      h1: "تواصل معنا – مكتب الإمارات",
      h2: "اشترِ في مصر وادفع من الإمارات",
      h3: ["خدمات التمويل للمغتربين والشركات", "تواصل معنا اليوم"],
      scripts: [
        {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "كونتكت",
          address: {
            "@type": "PostalAddress",
            streetAddress: "برج داماك إكس إل - مكتب 905، منطقة الأعمال",
            addressLocality: "دبي",
            addressCountry: "الإمارات العربية المتحدة",
          },
          telephone: "+971 54 700 4400",
          email: "info@contact.eg",
          url: "https://contact.eg/ar/contact-uae",
        },
      ],
    },

    productsBusiness: {
      factoring: {
        title: "خدمات التخصيم من كونتكت - التخصيم وتمويل الفواتير في مصر",
        meta_desc:
          "وفر سيولة أسرع لنشاطك التجاري مع خدمة التخصيم من كونتكت، وحول فواتير مبيعاتك لكاش فوري من غير ما تستنى مواعيد التحصيل، علشان تدير أعمالك بكفاءة ومرونة أكبر.",
        h1: "كن شريك كونتكت",
        h2: "برنامج كونتكت للمتاجر",
      },
      leasing: {
        title: "التأجير التمويلي في مصر من كونتكت | افضل حلول تمويل مرنة",
        meta_desc:
          "كونتكت بتقدم حلول تأجير تمويلي للشركات في مختلف القطاعات داخل مصر، مع خطط سداد مرنة ومصممة حسب احتياجاتك، علشان تساعدك توفر سيولة وتكبر مشروعك بخطوات أسرع.",
        h1: "",
        h2: "",
      },
    },
    whyContact: {
      title: "ليه تختار كونتكت - اختار افضل حلول تمويلية وتأمينية في مصر",
      meta_desc:
        "اكتشف ليه كونتكت اختيارك الأول للتمويل والتأمين. بنوفر لك خدمات تمويلية وتأمينية تناسب جميع مراحل حياتك، بأسرع وأسهل الإجراءات ومن غير ما تحتاج تروح أي مكان.",
      h1: "ليه تختار كونتكت لاحتياجاتك التمويلية والتأمينية؟",
      h2: "ركائزنا الاستراتيجية",
      h3: [
        "الخبرة والثقة",
        "مكان واحد للتمويل والتأمين",
        "تقدم على التمويل أو التأمين وأنت في مكانك",
        "تمكين طموحاتك",
      ],
      navigation_bar: {
        sections: [
          { id: 1, title: "خبرة و ثقة ", href: "Expertise&Trust" },
          {
            id: 2,
            title: "خدمات متكاملة في مكان واحد",
            href: "One-Stop-Shop",
          },
          {
            id: 3,
            title: "منتجاتنا التمويلية والتأمينية",
            href: "Financing_Insurance_Products",
          },

          { id: 4, title: "بندعم طموحك!", href: "Ambition" },
        ],
        contact_us: "تواصل معنا",
      },
      header: {
        title: (
          <>
            بنقدم حلولاً{" "}
            <strong style={{ color: colors.orange }}>
              {" "}
              <Box
                sx={{
                  position: "relative",
                  display: "inline-block",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  color: colors.orange,
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    border: `3px dashed ${colors.orange}`,
                    borderImageSource: `repeating-linear-gradient(55deg, ${colors.orange} 5px 20px, transparent 10px 30px)`,
                    borderImageSlice: 2,
                    borderRadius: "8px",
                    transform: "skew(0deg , 2.5deg)",
                  },
                }}
              >
                تمويلية و تأمينية
              </Box>{" "}
            </strong>
            لتمكين أحلامك <br /> و تحقيق طموحاتك.
          </>
        ),

        btn: "دعنا نستكشف",
        video:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/why-contact-android.mp4",
      },
      expertise: {
        title: "خبرة و ثقة",
        text: "على مدار أكتر من 20 سنة، كونتكت هي الشركة الرائدة في التمويل الاستهلاكي في مصر، بنقدّم لك حلول مالية تناسب كل مرحلة في حياتك. سواء محتاج تمويل لتحقيق أحلامك الكبيرة، تأمين شامل، أو خدمات دفع إلكترونية سهلة، إحنا معاك بخيارات سريعة، آمنة، ومرنة. وبخبرتنا الطويلة في عالم التمويل والتأمين، هنفضل دايماً جنبك علشان نسهّل عليك رحلتك المالية بكل ثقة وابتكار.",
        btn: "إكتشف منتجاتنا",
        statistic: [
          { id: "1", sufTheous: " ألف", text: "عميل", count: 425 },
          {
            id: "2",
            sufTheous: " ",
            text: "فرع علي مستوي جمهورية مصر العربية",
            count: 60,
          },
          {
            id: "3",
            sufTheous: " ألف",
            text: "أكبر شبكة تجار في مصر",
            count: 18,
          },
        ],
      },

      services: {
        mainTitle: "خدمات متكاملة في مكان واحد",
        title: (
          <p>
            مع <strong>كونتكت</strong> هتلاقي كل اللي محتاجه من{" "}
            <strong>تمويل وتأمين ومدفوعات إلكترونية</strong> بسهولة وسرعة في
            مكان واحد.
          </p>
        ),
        ourServices: [
          {
            id: 1,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-services-ar.png",
            text: "كونتكت للتمويل",
            color: colors.blue,
            link: "/",
          },
          {
            id: 2,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-life.png",
            text: "ثروة لتأمينات الحياة",
            color: colors.lemon_green,
            link: "/sarwa-life",
          },
          {
            id: 3,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-insurance.png",
            text: "ثروة للتأمين",
            color: colors.blue,
            link: "/sarwa-insurance",
          },
          {
            id: 4,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-insurance-ar.png",
            text: "كونتكت للوساطة التأمينية",
            color: colors.blue,
            link: "/products/insurance",
          },
          {
            id: 5,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-why.png",
            text: "مدفوعات إلكترونية",
            color: colors.orange,
            link: "/e-payment",
          },
        ],
      },

      financingInsuranceProducts: {
        title: (
          <p>
            بكل سهولة وسرعة تقدر تعرف أكتر عن منتجاتنا{" "}
            <strong> التمويلية والتأمينية</strong> وتقدم على طلب التمويل أو
            التأمين وأنت في مكانك
          </p>
        ),
        products: [
          {
            id: 1,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mockup-block-1.png",
            title: "موقعنا الإلكتروني Contact.eg",
            text: "بنقدملك تجربة مختلفة ومتطورة من حلول وخدمات التمويل والتأمين للأفراد والشركات سواء من موبايلك، لاب توب، تابلت، علشان نكون دايماً إختيارك الأول للتمويل والتأمين",
            link: "/",
            services: [
              {
                id: 1,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/online-services.svg",
                text: "تقدر من خلال موقعنا تعرف كل المعلومات إللي محتاجها عن منتجاتنا وخدماتنا التمويلية",
              },
              {
                id: 2,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/installment.svg",
                text: " تقدر تحسب أقساطك بكل سرعة وسهولة",
              },
              {
                id: 3,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/save-money.svg",
                text: "تقدر تقدم على طلب التمويل والتأمين من وأنت في مكانك",
              },
              {
                id: 4,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/repayment-periods.svg",
                text: "تقدر تتابع أقساطك، منتجاتك، نقاطك، عن طريق حسابك الشخصي",
              },
            ],
          },
          {
            id: 2,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mockup-block-2.png",
            title: "موبايل ابلكيشن كونتكت",
            text: `موبايل ابلكيشن "كونتكت ناو" تقدر من عليه تعرف كل المعلومات إللي محتاجها عن منتجاتنا التمويلية والتأمينية وتقدم على طلب التمويل من وأنت في مكانك، وتقدر ايضاً تستفاد بمجموعة متنوعة من عروض التقسيط إللي تهمك`,
            link: "https://onelink.to/frpjkg",
            services: [
              {
                id: 1,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/online-services.svg",
                text: "موافقة فورية على الحد الائتماني",
              },
              {
                id: 2,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/credit-limits.svg",
                text: "طلب زيادة الحد الائتماني",
              },
              {
                id: 3,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bills.svg",
                text: "دفع فواتيرك وأقساطك",
              },
              {
                id: 4,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/merchants.svg",
                text: "معرفة شبكة التجار",
              },
            ],
          },
          {
            id: 3,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mockup-block-3.png",
            title: "موبايل ابلكيشن كونتكت للوساطة التأمينية",
            text: " موبايل ابلكيشن كونتكت للوساطة التأمينية هيقدملك كل اللي يخص التأمين، وهيساعدك تفهم وتختار الخطة المناسبة ليك، لعيلتك، أو حتى لشغلك، بالإضافة لخدمات تانيه كتير تخلي حياتك أسهل وأكثر جودة",
            link: "https://qr.me-qr.com/4UGQWwew",
            services: [
              {
                id: 1,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/repayment-periods.svg",
                text: "تقدر عن طريق الابلكيشن تقدم المطالبات التأمينية",
              },
              {
                id: 2,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/medical-consultations.svg",
                text: " نصائح تهمك لصحتك البدنية",
              },
              {
                id: 3,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/physical-health.svg",
                text: "طلب استشارات طبية و تذكيرك بمواعيد أدويتك",
              },
              {
                id: 4,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/save-money.svg",
                text: "طلب الخدمات التأمينية الخاصة بك، أو بأسرتك، أو اعمالك",
              },
            ],
          },
          {
            id: 4,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mockup-block-4.png",
            title: "واتس آب كونتكت",
            text: "واتس آب كونتكت هو مساعدك السريع لكل احتياجاتك، سواء في التمويل أو التأمين! تقدر عن طريقه تعرف أكتر عن منتجاتنا وخدماتنا، وجاهز يساعدك أي وقت خلال الإسبوع. واتس آب كونتكت سريع، سهل، وبضغطة زرار بس!",
            link: "https://wa.me/20216177",
            services: [
              {
                id: 1,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/online-services.svg",
                text: "ردود سريعة",
              },
              {
                id: 2,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/availability.svg",
                text: "مُتاح لخدمتك على مدار الإسبوع",
              },
              {
                id: 3,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/repayment-periods.svg",
                text: "تقدر تتابع أقساطك، منتجاتك، نقاطك، عن طريق واتس آب كونتكت",
              },
              {
                id: 4,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/save-money.svg",
                text: "تقدر تقدم طلبات التمويل والتأمين من مكانك وبكل سهولة",
              },
            ],
          },
        ],
      },

      ambition: {
        bgImage:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contatct-ambition.png",
        logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-logo-ar.png",
        title: "بندعم طموحك!",
        description:
          "كونتكت بتفهم طموحاتك وبتساعدك تحقق أحلامك، وبتقرب منك عشان تقدم لك حلول مبتكرة تناسب احتياجاتك، مش بس تمويل.. لكنها جزء من حياتك اليومية!",
        btn: "تواصل معنا",
      },
    },
    paymentChannels: {
      title: "طرق الدفع مع كونتكت | سدد أقساطك أونلاين أو من خلال فروعنا",
      description:
        "دلوقتي تقدر تسدد أقساطك مع كونتكت بكل سهولة من خلال فروعنا او قنوات الدفع المختلفة زي فوري، إنستا باي، بي وغيرها. اختار الطريقة اللي تريحك وسدد وانت في مكانك.",
      scripts: [
        {
          "@context": "https://schema.org",
          "@type": "PaymentService",
          url: "https://contact.eg/payment-channels/",
          name: "طرق الدفع مع كونتكت | سدد أقساطك أونلاين أو من خلال فروعنا",
          description:
            "دلوقتي تقدر تسدد أقساطك مع كونتكت بكل سهولة من خلال فروعنا او قنوات الدفع المختلفة زي فوري، إنستا باي، بي وغيرها. اختار الطريقة اللي تريحك وسدد وانت في مكانك.",
          serviceType: "طرق الدفغ اونلاين",
          provider: {
            "@type": "Organization",
            name: "كونتكت",
            url: "https://contact.eg/",
            logo: "https://contact.eg/logo-ar.png",
            sameAs: [
              "https://www.facebook.com/ContactEg",
              "https://www.instagram.com/contact.eg/",
              "https://www.linkedin.com/company/contact-eg/",
            ],
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "16177",
              contactType: "خدمة عملاء كونتكت",
              availableLanguage: ["Arabic"],
            },
          },
          areaServed: [{ "@type": "Country", name: "Egypt" }],
          availableChannel: {
            "@type": "ServiceChannel",
            serviceUrl: "https://www.example.com/",
            availableLanguage: ["English", "Arabic"],
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "إيه هي قنوات الدفع الإلكتروني أو طرق الدفع المتاحة مع كونتكت؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "تقدر تسدد أقساطك مع كونتكت بسهولة عن طريق مجموعة متنوعة من قنوات الدفع الإلكتروني اللي تناسبك في أي وقت وأي مكان. تقدر تستعمل تطبيق كونتكت ناو لتجربة رقمية سهلة وسريعة، أو تدفع من خلال شركائنا المعتمدين: الأهلي ممكن، إنستا باي، مصاري، ضامن، فوري، أوباي، وسوبر باي. و قريب جدًا هنوفر قنوات سداد جديدة لكونتكت زي أمان، سهل، والبريد المصري",
              },
            },
            {
              "@type": "Question",
              name: "إيه هو تطبيق كونتكت ناو وإزاي أقدر أسدد أقساطي عليه؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "ContactNow هو التطبيق الرسمي من كونتكت واللي بيسهّل عليك سداد الأقساط عبر الإنترنت بطريقة بسيطة وآمنة. التطبيق بيجمع كل خدماتك المالية والتأمينية في مكان واحد. خطوات الدفع على ContactNow: افتح تطبيق كونتكت ناو وسجّل دخولك. من الصفحة الرئيسية، اختار Pay Your Bills .اختار Installments عشان تشوف المبالغ المستحقة ومواعيد السداد. راجع تفاصيل الدفع  زي القيمة، التاريخ، وجدول الأقساط. اختار طريقة الدفع اللي تناسبك ووافق على المبلغ. أكّد العملية واستلم إيصال الدفع الرقمي فورًا.",
              },
            },
            {
              "@type": "Question",
              name: "إزاي أقدر أدفع أقساطي عن طريق فوري؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "تقدر تدفع عن طريق فوري سواء من خلال تطبيق myFawry أو في أي فرع من فروع Fawry Plus أو المنافذ اللي عليها شعار فوري. عن طريق تطبيق myFawry: ادخل على الخدمات المالية > البنوك والخدمات المالية > الأقساط > كونتكت.اختار نوع القسط اللي عايز تسدده (سيارات - تعليم -تمويل عقاري - وغيرها). اكتب رقمك القومي اختار طريقة الدفع  أكّد العملية وهتوصلك رسالة بتأكيد الدفع فورًا. من خلال فروع فوري أو منافذ البيع: روح لأي منفذ عليه شعار فوري. سلّم الكاشير رقمك القومي. ادفع نقدي أو بكارت. استلم إيصال الدفع فورًا. ملاحظة: فوري بيضيف رسوم بسيطة على كل عملية",
              },
            },
            {
              "@type": "Question",
              name: "إزاي أقدر أدفع أقساطي عن طريق إنستا باي؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "مع إنستا باي، تقدر تسدد أقساطك بسهولة وفي أي وقت من خلال موبايلك أونلاين. خطوات الدفع: افتح تطبيق InstaPay واضغط على Bill Payment.من قائمة الخدمات، اختار الخدمات المالية > Contact. حدد نوع القسط اللي عايز تسدده. أدخل الرقم القومي والمبلغ المطلوب. راجع التفاصيل واضغط تأكيد بإدخال الـPIN الخاص بيك. ملاحظة: في حالة إن العملية نجحت وماظهرتش في حسابك، اتواصل مع البنك برقم العملية.",
              },
            },
            {
              "@type": "Question",
              name: "هل في طرق دفع جديدة جاية قريب؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "أكيد! إحنا دايمًا بنطوّر خدمات الدفع الإلكتروني مع كونتكت علشان نسهّل عليك. قريب جدًا هتقدر تدفع من خلال أمان وسهل، وكمان البريد المصري خلال الشهور الجاية. تابعنا على موقعنا أو تطبيق كونتكت ناو علشان تعرف أول بأول كل جديد.",
              },
            },
            {
              "@type": "Question",
              name: "أعمل إيه لو الدفع ما تمّش أو اتأخر؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "لو عملية الدفع ما ظهرتش فورًا أو مكتوب إنها قيد المراجعة، اتبع الخطوات دي: راجع حالة العملية في التطبيق (ناجحة - مرفوضة - قيد التنفيذ). احتفظ بإيصال الدفع سواء كان ورقي أو إلكتروني. في حالة العملية اترفضت، المبلغ بيرجع تلقائي لحسابك. لو ما حصلش، اتواصل مع البنك. للمساعدة من كونتكت: تقدر تتواصل معانا من خلال تطبيق كونتكت ناو، أو موقعنا الإلكتروني، أو كلمنا على 16177. وكمان تقدر تروح لأي فرع من فروع كونتكت.",
              },
            },
            {
              "@type": "Question",
              name: "ليه أختار قنوات الدفع مع كونتكت لسداد الأقساط؟",
              acceptedAnswer: {
                "@type": "Answer",
                text: "لأن كونتكت بتقدملك أكتر قنوات سداد متنوعة في مصر علشان تختار الطريقة اللي تريحك، سواء أونلاين أو في المنافذ. راحة ومرونة: ادفع في أي وقت ومن أي مكان من خلال التطبيقات أو أكتر من 500 ألف منفذ بيع. تجربة متكاملة: من خلال ContactNow، تقدر تدير تمويلك وتدفع أقساطك وتستفيد من خدمات التأمين في مكان واحد. ابتكار رقمي: أكتر من 24 سنة خبرة وشراكات قوية مع أهم بوابات الدفع في مصر زي فوري وإنستا باي. ثقة وخبرة: كونتكت من أكبر شركات التمويل غير المصرفي في مصر بخبرة طويلة ومصداقية عالية.",
              },
            },
          ],
        },
      ],
      slug: "طرق-الدفع",
    },
    financing: {
      title: "اشتري عربيتك دلوقتي بفائدة 4.4% وصيانة مجانية من كونتكت",
      meta_desc:
        "احصل على عربيتك الجديدة من كونتكت بفائدة 4.4% فقط وبدون مصاريف إدارية، صيانة مجانية 3 سنين وضمان لمدة 5 سنوات. سجّل طلب التمويل دلوقتي واستلم عربيتك بسهولة.",
    },
    ads: {
      title: "حقق كل أحلامك وأكتر بكتير مع كونتكت | سجل بياناتك دلوقتي",
      meta_desc:
        " كل إللي بتحلم بيه وأكتر بكتير في متناول إيدك مع كونتكت. سجل بياناتك دلوقتي مع كونتكت وهنتواصل معاك في الوقت اللي يناسبك عشان نساعدك تحقق أهدافك.",
    },
    campaign: {
      title: "شكراً لتواصلك مع كونتكت | فريقنا هيتواصل معاك قريب جداً",
      meta_desc:
        "شكراً لتواصلك مع كونتكت! استلمنا بياناتك وهيتواصل معاك أحد ممثلينا في أقرب وقت ممكن لمساعدتك في اي سؤال عن التمويل اللي انت محتاجه عشان تشوف الافضل ليك.",
    },
  },
  Erroruploadingfile: "حدث خطا فى رفع الملف حاول مره اخري ",
  connectionError:
    "تم الكشف عن مشكلة في الشبكة. يرجى التحقق من الاتصال وإعادة المحاولة.",
  branches: {
    hero: {
      title: "افضل حلول التمويل بـ{{branch}}",
      desc: "فرع كونتكت بـ{{branch}} بيوفر لك مجموعة متنوعة من خدمات وبرامج التمويل",
      cta: " استكشف المزيد",
      expertiseTitle: "مدعومة بأكثر من20 عامًا من الخبرة",
      expertiseDesc:
        "كونتكت كمان بتوفر لك تأمين يحميك ويحمي اللي يهموك، برامج ادخار ذكية تساعدك تحقق أهدافك، فرص استثمار تعزز مستقبلك المالي، ووسائل دفع مرنة وسهلة تناسب نمط حياتك وميزانيتك.",
    },
    stats: {
      customers: "عميل خدمناهم بكل فخر",
      transactions: "معاملة مالية ناجحة",
      branches: "فرع في جميع أنحاء الجمهورية",
      merchant: " أكبر شبكة تجار في مصر",
      customersCount: 425000,
      transactionsCount: 750000,
      merchantCount: 18000,
      branchesCount: 60,
    },
    services: {
      title: "الخدمة المقدمة",
      body: "بيقدم فرع كونتكت في {{branch}} باقة متكاملة من الخدمات المالية الشاملة في الفرع، بنوفرلك خيارات متعددة من أنظمة التقسيط المرنة، بحيث تختار الخطة الأنسب لك ولميزانيتك بكل حرية بمقدّم يبدأ من 10٪ فقط، وتمويل يصل إلى 10 مليون جنيه على مدار 5 سنين، فريقنا من الخبراء جاهز لمساعدتك في مجموعة واسعة من الحلول التمويلية المصممة لتناسب احتياجاتك",
      branchAlt: "فرع كونتكت",
    },
    why: {
      title: "لماذا تختار كونتكت فرع {{branch}}؟",
      lead: "في فرع كونتكت، {{branch}} إحنا دايمًا سابقين بخطوة عشان نسهّل عليك تجربتك المالية! معانا، هتستفيد من:",
      items: [
        "أكثر من 20 سنة خبرة موثّقة في مجال التمويل في مصر.",
        "حلول مالية على مزاجك، مصممة مخصوص لسكان {{branch}} في كل مراحل الحياة",
        "موافقة سريعة وسهلة",
        "تأمين شامل يحافظ على كل حاجة غالية عندك",
        "خدمات دفع إلكتروني ذكية. آمنة وسريعة ومن غير تعب",
        "كل ده بدعم من خبرات طويلة في التمويل والتأمين… يعني معانا، أنت في أمان!  ",
      ],
    },

    about: {
      paragraphs: [
        `احنا في كونتكت فخورين إننا جزء من مجتمع  {{branch}}  النشيط واللي بيكبر كل يوم! {{branch}} مش بس مكان جميل ومتخطط صح، دي كمان مليانة ناس مميزة وبنية تحتية على أعلى مستوى.`,
        "وفرعنا موجود في مكان سهل توصله، علشان نقدّم لك كل الخدمات المالية اللي محتاجها وتناسب حياتك.",

        "عايز تقسّط عربية؟ محتاج تأمين يغطّي كل حاجة؟ أو بتدور على طرق دفع ذكية وسهلة فريقنا موجود ويساعدك خطوة بخطوة، بخبرة وثقة.",
        "إحنا مش بس شركة تمويل… إحنا شريكك الحقيقي في مشوارك المالي، ومن قلب {{branch}}.",
      ],
    },
    steps: {
      defaultSteps: [
        {
          number: "1",
          title: "قم بزيارة فرع {{branch}}",
          Icon: "/apartment.svg",
        },
        {
          number: "2",
          title: "تحدث مع فريقنا واطرح استفساراتك",
          Icon: "/question.svg",
        },
        {
          number: "3",
          title: "قدّم المستندات المطلوبة",
          Icon: "/submit.svg",
        },
        {
          number: "4",
          title: "احصل على الموافقة بسرعة وسهولة",
          Icon: "/verified.svg",
        },
      ],
    },
    cursuror: {
      title: "الخدمات المتاحة في فرع {{branch}}",
      items: [
        {
          title: "السيارات",
          features: [
            "خبرة اكتر من 24 سنة في تمويل السيارات",
            "أكتر من 7 أنظمة تقسيط",
            "تمويل سيارات جديدة، مستعملة، و كهربائية",
          ],
          icon: "/services/car.svg",
          url: "/products/auto",
        },
        {
          title: "الدراجات النارية والسكوتر",
          features: [
            "تمويل لكل ماركات الموتوسيكلات",
            "تمويل علي اطول فترة سداد",
            "اكبر قيمة تمويل",
          ],
          icon: "/services/motorcycle.svg",
          url: "/products/motorcycles",
        },
        {
          title: "التعليم",
          features: [
            "تقسيط كل مراحل التعليم سواء لأولادك أو ليك",
            "بدون مقدم",
            "اكبر قيمة تمويل للتعليم",
          ],
          icon: "/services/education.svg",
          url: "/products/education",
        },
        {
          title: "النقل",
          features: [
            "خطط تقسيط للافراد و لأصحاب المهن",
            "تمويل علي اطول فترة سداد",
            "اكبر قيمة تمويل",
          ],
          icon: "/services/lorry.svg",
          url: "/products/trucks",
        },
        {
          title: " الأثاث وتجهيزات المنزل",
          features: [
            "إمكانية دمج عروض سعر مختلفة في نفس الطلب",
            "أطول فترة سداد",
            "اكبر قيمة تمويل",
          ],
          icon: "/services/home-furniture.svg",
          url: "/products/home-furniture",
        },
        {
          title: "النوادي",
          features: [
            "تفعيل فوري للعضوية",
            "تقسيط عضوية كل الأندية في مصر",
            "بدون مقدم",
          ],
          icon: "/services/clubs.svg",
          url: "/products/clubs",
        },
        {
          title: "تصميم وتشطيب",
          features: [
            "تشطيب بيتك بأسلوبك",
            "تمويل علي اطول فترة سداد",
            "اكبر قيمة تمويل",
          ],
          icon: "/services/design.svg",
          url: "/products/home-interior",
        },
        {
          title: "المركبات المائية",
          features: [
            "تمويل كل انواع وماركات المركبات المائية",
            "تمويل علي اطول فترة سداد",
            "تجربتك في البحر هتكون مختلفة",
          ],
          icon: "/services/watercraft.svg",
          url: "/products/watercraft",
        },
        {
          title: " أنظمة الطاقة الشمسية والبيوت الزراعية",
          features: [
            "أكبر قيمة تمويل",
            "أنظمة سداد مختلفة تناسب إمكانياتك",
            "تمويل ألواح الطاقة الشمسية، الصوب الزراعية، و كل إللي يحتاجه مشروعك",
          ],
          icon: "/services/green-finance.svg",
          url: "/products/green-finance",
        },
        {
          title: "التمويل العقاري",
          features: [
            "تمويل البيت إللي حلمت بيه",
            "تمويل علي اطول فترة سداد",
            "اكبر قيمة تمويل",
          ],
          icon: "/services/house.svg",
          url: "/products/mortgage",
        },
        {
          title: "الحج والعمرة",
          features: [
            "حقق حلمك وابدأ رحلتك الروحانية إلي بيت الله الحرام بكل سهولة",
            "متوافق مع أحكام الشريعة الإسلامية",
            "اطول فترة سداد",
          ],
          icon: "/services/manasik.svg",
          url: "/products/travel-and-tourism",
        },
      ],
    },
    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "ما هي مواعيد عمل فرع كونتكت في {{branch}}؟",
          a: "الفرع مفتوح يوميًا من الساعة 9:30 صباحًا حتى 5:30 مساءً (ما عدا يومي الجمعة والسبت).",
        },
        {
          q: "ما هي المستندات المطلوبة عند زيارة الفرع؟",
          a: " يُفضل إحضار بطاقة الرقم القومي لتسريع الخدمة. وسيقوم مستشارونا في الفرع بإبلاغك بأي مستندات إضافية حسب نوع الخدمة اللي محتاجها.",
        },
        {
          q: "هل لازم أحجز موعد قبل زيارة الفرع؟",
          a: "لا، الحجز غير مطلوب. يمكنك زيارتنا في أي وقت خلال مواعيد العمل، وفريقنا جاهز لمساعدتك.",
        },
      ],
    },
    footer: {
      title:
        "ما تستناش، خليك على الطريق مع كونتكت النهاردة! زور فرع {{branch}} ",
      description1: " قدم بسهولة وبأقل أوراق موافقة سريعة وخطط سداد مرنة",
      description2: "رحلتك تبدأ من هنا، وكونتكت توصلك للي نفسك فيه",
      callUS: "اتصل بنا ",
    },
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "FinancialService",
        name: "كونتكت - فرع {{branch}}",
        description:
          "هل تبحث عن فرع كونتكت في {{branch}}؟ احصل على الاتجاهات، مواعيد العمل، وبيانات الاتصال لفرعنا في {{branch}}. اتصلوا بنا على 16177.",
        url: "https://contact.eg/ar/branches/{{branch}}",
        telephone: "+2016177",
        address: {
          "@type": "PostalAddress",
          streetAddress: "{{address}}",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: "{{lat}}",
          longitude: "{{long}}",
        },
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
            opens: "09:30",
            closes: "17:30",
          },
        ],
        image: "https://contact.eg/path/to/logo.png",
        sameAs: [
          "https://www.facebook.com/ContactEgy",
          "https://www.linkedin.com/company/contact-financial-holding",
        ],
      },
    ],
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "ما هي مواعيد عمل فرع Contact.eg في {{branch}}",
          acceptedAnswer: {
            "@type": "Answer",
            text: "الفرع مفتوح يوميًا من الساعة 9:30 صباحًا حتى 5:30 مساءً (ما عدا يومي الجمعة والسبت)",
          },
        },
        {
          "@type": "Question",
          name: "ما هي المستندات المطلوبة عند زيارة الفرع؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "يُفضل إحضار بطاقة الرقم القومي لتسريع الخدمة. وسيقوم مستشارونا في الفرع بإبلاغك بأي مستندات إضافية حسب نوع الخدمة اللي محتاجها.",
          },
        },
        {
          "@type": "Question",
          name: "هل لازم أحجز موعد قبل زيارة الفرع؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "لا، الحجز مش مطلوب. تقدر تزورنا في أي وقت خلال مواعيد العمل، وفريقنا جاهز يساعدك.",
          },
        },
      ],
    },
  },
};
